webpackJsonp([112],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1bcz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
					value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// 常见问题
{
					path: 'service/faq',
					component: (0, _import3.default)('service/faq'),
					children: [{
										path: ':type',
										component: (0, _import3.default)('service/faq')
					}]
},
// 操作手册
{
					path: 'service/manual',
					component: (0, _import3.default)('service/manual'),
					children: [{
										path: ':type',
										component: (0, _import3.default)('service/manual')
					}]
},
// 在线支持
{
					path: 'service/support',
					component: (0, _import3.default)('service/support')
},
// 覆盖区域
{
					path: 'service/coverage',
					component: (0, _import3.default)('service/coverage')
},
// 企业方案
{
					path: 'service/enterprise',
					component: (0, _import3.default)('service/enterprise')
},
// 保养维修
{
					path: 'service/maintenance',
					component: (0, _import3.default)('service/maintenance')
},
// 安全措施
{
					path: 'service/safety_measures',
					component: (0, _import3.default)('service/safety_measures')
}];

/***/ }),

/***/ "2QS9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// g3
// {
//     path: 'cloudsim/g3',
//     component: _import('cloudsim/g3')
// },
// // u2
// {
//     path: 'cloudsim/u2',
//     component: _import('cloudsim/u2')
// },
// // why_glocalme_wifi
// {
//     path: 'cloudsim/why_glocalme_wifi',
//     component: _import('cloudsim/why_glocalme_wifi')
// },
// // roaming_free_wifi_g4pro
// {
//     path: 'cloudsim/roaming_free_wifi_g4pro',
//     component: _import('cloudsim/roaming_free_wifi_g4pro')
// },

// cloudsim 动态路由
{
    path: 'cloudsim/:type',
    component: (0, _import3.default)('cloudsim/common_wifi')
}];

/***/ }),

/***/ "3v4D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/***
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "us_mall": {
        "feature_one": "Free, fast shipping",
        "feature_two": "Free, easy return",
        "feature_three": "6-Month Warranty",
        "quantity": "Quantity:",
        "tax_tips": "Tax caculation",
        "buy": "Buy Now",
        "check_out": "Check out",
        "select_one": "Please select one data"
    },
    "product": {
        "choose_device_title": "Choose your device",
        "choose_package_title": "Choose your initial data package",
        "choose_accessory_title": "Would you like to add accessories?",
        "add_to_cart": "Add to cart"
    },
    "cart": {
        "cart_title": "My Cart",
        "remove": "Remove",
        "total": "TOTAL:"
    },
    "settlement": {
        "title": "SECURE CHECKOUT",
        "delivery": "Delivery",
        "pick_up": "Pick up",
        "form_title": "Enter your name and address",
        "country": "Country*",
        "required": "required field",
        "firstName": "First name*",
        "lastName": "Last name*",
        "address1": "Address line 1*",
        "address2": "Address line 2",
        "city": "City",
        "state": "State/Province/Region*",
        "zipCode": "Zip code*",
        "contactInfo": "Contact information",
        "email": "Email address*",
        "phone": "Phone number*",
        "contact_checked": "Subscribe to our news letter to receive exclusive deals",
        "ship": "Shipping method",
        "payment": "Payment method",
        "pickup_spot": "Available pickup spot",
        "name": "Name*",
        "order_summary": "Order Summary",
        "apply": "Apply",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "tax": "Tax",
        "total": "Total:",
        "privacy": "By placing this order, you agree to our<a href=\"/member/agreement\">Terms and Conditions</a> and <a href=\"/users/privacy_policy\">Privacy Policy</a>.",
        "order": "Place Order",
        "paymentCompleted": "Payment Completed",
        "wxScanTips": "Please use wechat to scan",
        "payForWeChat": "WeChat"
    },
    "cooperation": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "position": "Position",
        "companyName": "Company Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "productInterst": "Main Product of Interest",
        "estimatedQuantity": "Estimated Quantity of Product"
    }
};

/***/ }),

/***/ "5DhB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _events = __webpack_require__("vzCy");

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_LISTENERS = 100;
!function (root, factory) {
    root = root || {};
    if (!root.eventLib) {
        root.eventLib = factory();
    }
    if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
        module.exports = root.eventLib;
    }
    root.eventLib.setMaxListeners(MAX_LISTENERS);
}(typeof window !== 'undefined' ? window : undefined, function () {
    return new _events2.default.EventEmitter();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "5tgt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @author huancheng.zhan<huancheng.zhan@ukelink.com>
 * @description
 * @since 2018/3/7
 */

module.exports = function (file) {
  return function () {
    return __webpack_require__("MWF8")("./" + file);
  };
};

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4154764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("aN9Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c27a69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("ORne")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (confirm_Component.exports);


/***/ }),

/***/ "7kt1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A62N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by minghua.li on 2020/9/9.
 */
exports.default = {
    isPC: false,
    count: 0,
    cmsData: {}
};

/***/ }),

/***/ "BMh0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0178dc7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("BMh0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ECvG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    path: 'user-center',
    name: 'member',
    component: (0, _import3.default)('member/layout'),
    redirect: {
        name: 'member_account_list'
    },
    meta: {
        requiresAuth: true
    },
    children: [
    // 个人账户
    {
        path: 'account',
        name: 'member_account_list',
        component: (0, _import3.default)('member/account/list.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: 'account-detail/:ota',
        name: 'member_account_detail',
        component: (0, _import3.default)('member/account/detail.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: 'account-setting',
        name: 'member_account_setting',
        component: (0, _import3.default)('member/account/setting.vue'),
        meta: {
            requiresAuth: true
        }
    },
    // 个人账户取消
    {
        path: 'cancel/:ota',
        name: 'member_account_cancel',
        component: (0, _import3.default)('member/account/cancel.vue'),
        meta: {
            requiresAuth: true
        }
    }, {
        path: 'prompt',
        name: 'member_account_prompt',
        component: (0, _import3.default)('member/account/prompt.vue'),
        meta: {
            requiresAuth: true
        }
    },
    // 购买记录---我的订单
    {
        path: 'myOrder',
        name: 'member_myOrder',
        component: (0, _import3.default)('member/myOrder'),
        meta: {
            requiresAuth: true
        }
    },
    // 购买记录---设备订单
    {
        path: 'myDeviceOrder',
        name: 'myDeviceOrder',
        component: (0, _import3.default)('member/myDeviceOrder'),
        meta: {
            requiresAuth: true
        }
    },
    // 购买记录---设备订单详情
    {
        path: 'myDeviceOrderDetail',
        name: 'myDeviceOrderDetail',
        component: (0, _import3.default)('member/myDeviceOrderDetail'),
        meta: {
            requiresAuth: true
        }
    },
    // 我的余额---余额明细
    {
        path: 'balanceDetails',
        name: 'member_balanceDetails',
        component: (0, _import3.default)('member/balanceDetails'),
        meta: {
            requiresAuth: true
        }
    },
    // 流量统计---流量记录
    {
        path: 'flowRecords',
        name: 'member_flowRecords',
        component: (0, _import3.default)('member/flowRecords'),
        meta: {
            requiresAuth: true
        }
    },
    // 我的设备---设备管理
    {
        path: 'equipmentManagement',
        name: 'equipmentManagement',
        component: (0, _import3.default)('member/equipmentManagement'),
        meta: {
            requiresAuth: true
        }
    },
    // 修改密码
    {
        path: 'modify-password',
        name: 'modifyPassword',
        component: (0, _import3.default)('member/modifyPassword'),
        meta: {
            requiresAuth: true
        }
    },
    //
    {
        path: 'modify_information',
        name: 'modifyInformation',
        component: (0, _import3.default)('member/modify_information'),
        meta: {
            requiresAuth: true
        }
    },
    // 注册邮箱激活账户
    {
        path: 'activeAccount',
        name: 'active_account',
        component: (0, _import3.default)('register/active_account')
    },
    // 注册邮箱激活账户成功
    {
        path: 'activeAccountSuc',
        name: 'active_account_suc',
        component: (0, _import3.default)('register/active_account_suc')
    }]
}];

/***/ }),

/***/ "FeGY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/***
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "us_mall": {
        "feature_one": "Free, fast shipping",
        "feature_two": "Free, easy return",
        "feature_three": "6-Month Warranty",
        "quantity": "Quantity:",
        "tax_tips": "Tax caculation",
        "buy": "Buy Now",
        "check_out": "Check out",
        "select_one": "Please select one data"
    },
    "product": {
        "choose_device_title": "Choose your device",
        "choose_package_title": "Choose your initial data package",
        "choose_accessory_title": "Would you like to add accessories?",
        "add_to_cart": "Add to cart"
    },
    "cart": {
        "cart_title": "My Cart",
        "remove": "Remove",
        "total": "TOTAL:",
        "noCart_title": "Your cart is empty.",
        "noCart_subTitle": "Sign in to see if you have any saved items. Or continue shopping.",
        "sign": "Sign In",
        "shopping": "Continue Shopping"
    },
    "settlement": {
        "title": "SECURE CHECKOUT",
        "delivery": "Delivery",
        "pick_up": "Pick up",
        "form_title": "Enter your name and address",
        "country": "Country*",
        "required": "Required field",
        "firstName": "First name*",
        "lastName": "Last name*",
        "address1": "Address line 1*",
        "address2": "Address line 2",
        "city": "City",
        "state": "State/Province/Region*",
        "zipCode": "Zip code*",
        "contactInfo": "Contact information",
        "email": "Email address*",
        "phone": "Phone number*",
        "contact_checked": "Subscribe to our news letter to receive exclusive deals",
        "ship": "Shipping method",
        "payment": "Payment method",
        "pickup_spot": "Available pickup spot",
        "name": "Name*",
        "order_summary": "Order Summary",
        "apply": "Apply",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "tax": "Tax",
        "total": "Total:",
        "privacy": "By placing this order, you agree to our<a href=\"/member/agreement\">Terms and Conditions</a> and <a href=\"/users/privacy_policy\">Privacy Policy</a>.",
        "order": "Place Order",
        "paymentCompleted": "Payment Completed",
        "wxScanTips": "Please use wechat to scan",
        "payForWeChat": "WeChat",
        couponCode: "Promo code",
        couponRemove: "Remove",
        discountAmount: "Discount amount",
        requiredItems: "Required items"
    },
    "cooperation": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "position": "Position",
        "companyName": "Company Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "productInterst": "Main Product of Interest",
        "estimatedQuantity": "Estimated Quantity of Product"
    }
};

/***/ }),

/***/ "LwXw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import where_to_buy from '../views/glocalme/where_to_buy';

exports.default = [
// 购买渠道
{
    path: 'where_to_buy',
    component: (0, _import3.default)('glocalme/where_to_buy'),
    children: [{
        path: ':type',
        component: (0, _import3.default)('glocalme/where_to_buy')
    }]
}, {
    path: 'glocalme/where_to_buy',
    component: (0, _import3.default)('glocalme/where_to_buy')
}];

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//


/* harmony default export */ var App = ({
    name: 'app',
    data: function data() {
        return {
            customerInfo: {},
            imei: ""
        };
    },

    methods: {
        // async apiReady () {
        //     let access_token = this.cookieHelper.get('access_token');
        //     let signParams = {
        //         "nonce": this.getRandomString(12),
        //         "timestamp": new Date().getTime()
        //     };
        //     if (access_token) {
        //         let tempData = await this.getLoginCustomerImei().catch(() =>{});
        //         if (tempData && tempData.data && tempData.data.imei) {
        //             this.imei = tempData.data.imei;
        //         }
        //         signParams.web_token = localStorage.username;
        //     } else {
        //         signParams.web_token = `WEB_${this.getuDeskSessionKey()}`;
        //     }
        //     let tempData2 = await this.getuDeskSignature(signParams).catch(() => {});
        //     if (tempData2 && tempData2.data) {
        //         signParams.signature = tempData2.data;
        //     }
        //     this.customerInfo = this.getuDeskCustomerInfo(signParams);

        //     // <!-- uDesk客服接入 -->
        //     (function(a,h,c,b,f,g) {
        //         a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};
        //         g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)
        //     })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");

        //     // 初始化uDesk
        //     this.inituDesk();
        // },
        inituDesk: function inituDesk() {
            // uDesk客服接入init
            var code = "2k468g44",
                link = this.getuDeskLink(),
                session_key = this.getuDeskSessionKey(),
                language = this.getuDeskLanguage();

            var config = {
                "code": code,
                "link": link,
                "language": language,
                "session_key": session_key,
                "mobile": {
                    "mode": "blank", // 独立窗口模式
                    "selector": ".btn_uDesk"
                }
            };
            config.manualInit = deviceWidth > 768;
            config.customer = this.customerInfo;
            ud(config);
        },
        getuDeskCustomerInfo: function getuDeskCustomerInfo(obj) {
            // uDesk客服发送客户信息
            var tempUserInfo = localStorage.userInfo,
                userInfo = {};
            if (tempUserInfo) {
                userInfo = JSON.parse(tempUserInfo);
            }
            var customer = {
                "c_name": "WEB_" + this.getuDeskSessionKey()
            };
            if (userInfo && userInfo.registerType === "PHONE") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.phone;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }
            if (userInfo && userInfo.registerType === "EMAIL") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.email;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }

            customer = extends_default()({}, customer, obj);
            return customer;
        },
        getuDeskLink: function getuDeskLink() {
            // uDesk客服接入link
            var commonLink = "//ucloudlink.udesk.cn/im_client/",
                normal_id = "58735",
                // 通用客服ID
            us_id = "58737",
                // 美国站点专用客服ID
            ca_id = "129711",
                // 加拿大站专用客服ID
            g_iso = this.cookieHelper.get("g_iso") || "CN";
            var normalLink = commonLink + "?web_plugin_id=" + normal_id,
                usLink = commonLink + "?web_plugin_id=" + us_id,
                caLink = commonLink + "?web_plugin_id=" + ca_id,
                link = "";

            if (g_iso.toUpperCase() === 'US') {
                link = usLink;
            } else if (g_iso.toUpperCase() === 'CA') {
                link = caLink;
            } else {
                link = normalLink;
            }

            return link;
        },
        getuDeskLanguage: function getuDeskLanguage() {
            // uDesk客服接入language
            var languageArray = ["zh-cn", "zh-TW", "en-us"],
                // 简体中文、繁体中文、英文
            language = this.cookieHelper.get("language") || "zh-CN",
                uDeskLanguage = "";

            if (language === "zh-HK" || language === "zh-TW") {
                uDeskLanguage = languageArray[1];
            } else if (language === "en-US") {
                uDeskLanguage = languageArray[2];
            } else {
                uDeskLanguage = languageArray[0];
            }
            return uDeskLanguage;
        },
        getuDeskSessionKey: function getuDeskSessionKey() {
            // uDesk客服接入session_key
            var sessionKey = localStorage.sessionKey;
            if (sessionKey) {
                return sessionKey;
            } else {
                var tempKey = this.getRandomString(6);
                localStorage.setItem("sessionKey", tempKey);
                return tempKey;
            }
        },
        getRandomString: function getRandomString(n) {
            // 生成n位字符串
            // randomArray 生成随机字母，数字的数组容器[A-Za-z0-9]
            var randomArray = [],
                randomString = "",
                len = void 0;

            for (var i = 0; i < 26; i++) {
                randomArray.push(String.fromCharCode(i + 65));
                randomArray.push(String.fromCharCode(i + 97));
            }
            for (var j = 0; j <= 9; j++) {
                randomArray.push(j);
            }
            len = randomArray.length;

            do {
                randomString += randomArray[Math.floor(Math.random() * len)];
                n--;
            } while (n > 0);

            return randomString;
        },
        checkGiso: function checkGiso() {
            var that = this;
            var access_token = this.cookieHelper.get('access_token');
            var SL_COUNTRY = this.cookieHelper.get('SL_COUNTRY') || 'US'; // 临时
            var GM_COUNTRY = this.cookieHelper.get('GM_COUNTRY');

            // 如果登陆，并且选择地区与账号地区不同
            if (access_token && access_token.length > 0 && GM_COUNTRY !== SL_COUNTRY) {
                this.$http.post(this.$api.interfaces.getCountryInfo + "?giso=" + SL_COUNTRY, {
                    keyword: "",
                    search: 1
                }).then(function (d) {
                    var country_name = '';
                    d = d.data;
                    for (var key in d) {
                        if (d.hasOwnProperty(key) && d[key].iso2 === GM_COUNTRY) {
                            country_name = d[key].countryName;
                            break;
                        }
                    }

                    if (country_name) {
                        var title = void 0,
                            content = void 0;
                        title = that.$t('footer.belongs') + country_name + that.$t('footer.site');
                        content = that.$t('footer.switchWebsite');
                        that.$vux.confirm.show({
                            title: title,
                            content: content,
                            confirmText: that.$t('common.confirm'),
                            cancelText: that.$t('common.cancel'),
                            onCancel: function onCancel() {
                                var uri = location.pathname.replace(/\/[A-Z]{2}/, function (a) {
                                    return '/' + GM_COUNTRY;
                                });
                                location.replace(uri);
                            },
                            onConfirm: function onConfirm() {
                                that.cookieHelper.remove("access_token", { domain: "." + location.hostname });
                                that.cookieHelper.remove("GM_COUNTRY", { domain: "." + location.hostname });
                                that.cookieHelper.remove("SL_COUNTRY", { domain: "." + location.hostname });
                                that.cookieHelper.remove("g_iso", { domain: "." + location.hostname });
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            }
                        });
                    }
                });
            }
        },
        getLoginCustomerImei: function getLoginCustomerImei() {
            // 获取登录账户的绑定IMEI
            vue_esm["default"].prototype.NotInterceptors = true;
            return this.$http.post(this.$api.equipmentManagement.queryDeviceBindingInfo, {
                loginCustomerId: localStorage.getItem('loginCustomerId'),
                customerName: localStorage.getItem('username')
            });
        },
        getuDeskSignature: function getuDeskSignature(obj) {
            // 获取生成的uDesk鉴权字符串
            return this.$http.post(this.$api.interfaces.getuDeskSign, obj);
        },

        // 获取或保存用户协议和隐私政策的版本号
        pushInformationVersion: function pushInformationVersion(obj) {
            return this.$http.post(this.$api.interfaces.pushInformation, obj);
        },

        // 检测登录账号是否需要提示用户协议和隐私政策变更
        checkPolicyVersion: function checkPolicyVersion() {
            var _this = this;

            if (this.cookieHelper.get("access_token")) {
                var param = {
                    userCode: localStorage.username,
                    langType: this.commonHelper.getLanguage(this.cookieHelper.get("language")),
                    iso: this.cookieHelper.get("g_iso")
                };
                this.pushInformationVersion(param).then(function (response) {
                    // 返回结果 push为true 提示用户政策变更
                    if (response.data && response.data.push === true) {
                        _this.$vux.confirm.show({
                            title: _this.$t('privacyPolicy.changeDate'),
                            content: _this.$t('privacyPolicy.changeContain') + '<div style="padding: 0.1rem 0">' + _this.$t('privacyPolicy.changeContain2') + '</div>' + _this.$t('privacyPolicy.changeContain3'),
                            confirmText: _this.$t('privacyPolicy.agree'),
                            cancelText: _this.$t('privacyPolicy.noagree'),
                            onCancel: function onCancel() {
                                _this.cookieHelper.remove("access_token", { domain: "." + location.hostname });
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            },
                            onConfirm: function onConfirm() {
                                // 选择同意，提交变更版本信息
                                param.registrationAgreement = response.data.registrationAgreement;
                                param.privacyPolicy = response.data.privacyPolicy;
                                _this.pushInformationVersion(param);
                            }
                        });
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        // this.checkGiso();
        this.checkPolicyVersion();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_App = ({
    name: 'app',
    data: function data() {
        return {
            customerInfo: {},
            imei: ""
        };
    },

    methods: {
        // async apiReady () {
        //     let access_token = this.cookieHelper.get('access_token');
        //     let signParams = {
        //         "nonce": this.getRandomString(12),
        //         "timestamp": new Date().getTime()
        //     };
        //     if (access_token) {
        //         let tempData = await this.getLoginCustomerImei().catch(() =>{});
        //         if (tempData && tempData.data && tempData.data.imei) {
        //             this.imei = tempData.data.imei;
        //         }
        //         signParams.web_token = localStorage.username;
        //     } else {
        //         signParams.web_token = `WEB_${this.getuDeskSessionKey()}`;
        //     }
        //     let tempData2 = await this.getuDeskSignature(signParams).catch(() => {});
        //     if (tempData2 && tempData2.data) {
        //         signParams.signature = tempData2.data;
        //     }
        //     this.customerInfo = this.getuDeskCustomerInfo(signParams);

        //     // <!-- uDesk客服接入 -->
        //     (function(a,h,c,b,f,g) {
        //         a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};
        //         g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)
        //     })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");

        //     // 初始化uDesk
        //     this.inituDesk();
        // },
        inituDesk: function inituDesk() {
            // uDesk客服接入init
            var code = "2k468g44",
                link = this.getuDeskLink(),
                session_key = this.getuDeskSessionKey(),
                language = this.getuDeskLanguage();

            var config = {
                "code": code,
                "link": link,
                "language": language,
                "session_key": session_key,
                "mobile": {
                    "mode": "blank", // 独立窗口模式
                    "selector": ".btn_uDesk"
                }
            };
            config.manualInit = deviceWidth > 768;
            config.customer = this.customerInfo;
            ud(config);
        },
        getuDeskCustomerInfo: function getuDeskCustomerInfo(obj) {
            // uDesk客服发送客户信息
            var tempUserInfo = localStorage.userInfo,
                userInfo = {};
            if (tempUserInfo) {
                userInfo = JSON.parse(tempUserInfo);
            }
            var customer = {
                "c_name": "WEB_" + this.getuDeskSessionKey()
            };
            if (userInfo && userInfo.registerType === "PHONE") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.phone;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }
            if (userInfo && userInfo.registerType === "EMAIL") {

                // "账户"、"IMEI1"为客服自定义字段
                customer.c_cf_账户 = userInfo.email;
                if (this.imei) {
                    customer.c_cf_IMEI1 = this.imei;
                }
            }

            customer = extends_default()({}, customer, obj);
            return customer;
        },
        getuDeskLink: function getuDeskLink() {
            // uDesk客服接入link
            var commonLink = "//ucloudlink.udesk.cn/im_client/",
                normal_id = "58735",
                // 通用客服ID
            us_id = "58737",
                // 美国站点专用客服ID
            ca_id = "129711",
                // 加拿大站专用客服ID
            g_iso = this.cookieHelper.get("g_iso") || "CN";
            var normalLink = commonLink + "?web_plugin_id=" + normal_id,
                usLink = commonLink + "?web_plugin_id=" + us_id,
                caLink = commonLink + "?web_plugin_id=" + ca_id,
                link = "";

            if (g_iso.toUpperCase() === 'US') {
                link = usLink;
            } else if (g_iso.toUpperCase() === 'CA') {
                link = caLink;
            } else {
                link = normalLink;
            }

            return link;
        },
        getuDeskLanguage: function getuDeskLanguage() {
            // uDesk客服接入language
            var languageArray = ["zh-cn", "zh-TW", "en-us"],
                // 简体中文、繁体中文、英文
            language = this.cookieHelper.get("language") || "zh-CN",
                uDeskLanguage = "";

            if (language === "zh-HK" || language === "zh-TW") {
                uDeskLanguage = languageArray[1];
            } else if (language === "en-US") {
                uDeskLanguage = languageArray[2];
            } else {
                uDeskLanguage = languageArray[0];
            }
            return uDeskLanguage;
        },
        getuDeskSessionKey: function getuDeskSessionKey() {
            // uDesk客服接入session_key
            var sessionKey = localStorage.sessionKey;
            if (sessionKey) {
                return sessionKey;
            } else {
                var tempKey = this.getRandomString(6);
                localStorage.setItem("sessionKey", tempKey);
                return tempKey;
            }
        },
        getRandomString: function getRandomString(n) {
            // 生成n位字符串
            // randomArray 生成随机字母，数字的数组容器[A-Za-z0-9]
            var randomArray = [],
                randomString = "",
                len = void 0;

            for (var i = 0; i < 26; i++) {
                randomArray.push(String.fromCharCode(i + 65));
                randomArray.push(String.fromCharCode(i + 97));
            }
            for (var j = 0; j <= 9; j++) {
                randomArray.push(j);
            }
            len = randomArray.length;

            do {
                randomString += randomArray[Math.floor(Math.random() * len)];
                n--;
            } while (n > 0);

            return randomString;
        },
        checkGiso: function checkGiso() {
            var that = this;
            var access_token = this.cookieHelper.get('access_token');
            var SL_COUNTRY = this.cookieHelper.get('SL_COUNTRY') || 'US'; // 临时
            var GM_COUNTRY = this.cookieHelper.get('GM_COUNTRY');

            // 如果登陆，并且选择地区与账号地区不同
            if (access_token && access_token.length > 0 && GM_COUNTRY !== SL_COUNTRY) {
                this.$http.post(this.$api.interfaces.getCountryInfo + "?giso=" + SL_COUNTRY, {
                    keyword: "",
                    search: 1
                }).then(function (d) {
                    var country_name = '';
                    d = d.data;
                    for (var key in d) {
                        if (d.hasOwnProperty(key) && d[key].iso2 === GM_COUNTRY) {
                            country_name = d[key].countryName;
                            break;
                        }
                    }

                    if (country_name) {
                        var title = void 0,
                            content = void 0;
                        title = that.$t('footer.belongs') + country_name + that.$t('footer.site');
                        content = that.$t('footer.switchWebsite');
                        that.$vux.confirm.show({
                            title: title,
                            content: content,
                            confirmText: that.$t('common.confirm'),
                            cancelText: that.$t('common.cancel'),
                            onCancel: function onCancel() {
                                var uri = location.pathname.replace(/\/[A-Z]{2}/, function (a) {
                                    return '/' + GM_COUNTRY;
                                });
                                location.replace(uri);
                            },
                            onConfirm: function onConfirm() {
                                that.cookieHelper.remove("access_token", { domain: "." + location.hostname });
                                that.cookieHelper.remove("GM_COUNTRY", { domain: "." + location.hostname });
                                that.cookieHelper.remove("SL_COUNTRY", { domain: "." + location.hostname });
                                that.cookieHelper.remove("g_iso", { domain: "." + location.hostname });
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            }
                        });
                    }
                });
            }
        },
        getLoginCustomerImei: function getLoginCustomerImei() {
            // 获取登录账户的绑定IMEI
            vue_esm["default"].prototype.NotInterceptors = true;
            return this.$http.post(this.$api.equipmentManagement.queryDeviceBindingInfo, {
                loginCustomerId: localStorage.getItem('loginCustomerId'),
                customerName: localStorage.getItem('username')
            });
        },
        getuDeskSignature: function getuDeskSignature(obj) {
            // 获取生成的uDesk鉴权字符串
            return this.$http.post(this.$api.interfaces.getuDeskSign, obj);
        },

        // 获取或保存用户协议和隐私政策的版本号
        pushInformationVersion: function pushInformationVersion(obj) {
            return this.$http.post(this.$api.interfaces.pushInformation, obj);
        },

        // 检测登录账号是否需要提示用户协议和隐私政策变更
        checkPolicyVersion: function checkPolicyVersion() {
            var _this = this;

            if (this.cookieHelper.get("access_token")) {
                var param = {
                    userCode: localStorage.username,
                    langType: this.commonHelper.getLanguage(this.cookieHelper.get("language")),
                    iso: this.cookieHelper.get("g_iso")
                };
                this.pushInformationVersion(param).then(function (response) {
                    // 返回结果 push为true 提示用户政策变更
                    if (response.data && response.data.push === true) {
                        _this.$vux.confirm.show({
                            title: _this.$t('privacyPolicy.changeDate'),
                            content: _this.$t('privacyPolicy.changeContain') + '<div style="padding: 0.1rem 0">' + _this.$t('privacyPolicy.changeContain2') + '</div>' + _this.$t('privacyPolicy.changeContain3'),
                            confirmText: _this.$t('privacyPolicy.agree'),
                            cancelText: _this.$t('privacyPolicy.noagree'),
                            onCancel: function onCancel() {
                                _this.cookieHelper.remove("access_token", { domain: "." + location.hostname });
                                localStorage.clear();
                                sessionStorage.clear();
                                location.reload();
                            },
                            onConfirm: function onConfirm() {
                                // 选择同意，提交变更版本信息
                                param.registrationAgreement = response.data.registrationAgreement;
                                param.privacyPolicy = response.data.privacyPolicy;
                                _this.pushInformationVersion(param);
                            }
                        });
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        // this.checkGiso();
        this.checkPolicyVersion();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d066a64a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"view"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("XmAf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MWF8":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404": [
		"+H76",
		60
	],
	"./404.vue": [
		"+H76",
		60
	],
	"./PagesView": [
		"iMmR"
	],
	"./PagesView.vue": [
		"iMmR"
	],
	"./about/contact": [
		"0GNx",
		0,
		41
	],
	"./about/contact.vue": [
		"0GNx",
		0,
		41
	],
	"./about/glocalme": [
		"7nHx",
		0,
		63
	],
	"./about/glocalme.vue": [
		"7nHx",
		0,
		63
	],
	"./about/news": [
		"p8kA",
		0,
		26
	],
	"./about/news.vue": [
		"p8kA",
		0,
		26
	],
	"./about/newsDetail": [
		"gBRZ",
		0,
		74
	],
	"./about/newsDetail.vue": [
		"gBRZ",
		0,
		74
	],
	"./about/partnership": [
		"sblS",
		0,
		71
	],
	"./about/partnership.vue": [
		"sblS",
		0,
		71
	],
	"./cloudsim/common_wifi": [
		"3bPk",
		0,
		31
	],
	"./cloudsim/common_wifi.vue": [
		"3bPk",
		0,
		31
	],
	"./cloudsim/g3": [
		"drMB",
		0,
		35
	],
	"./cloudsim/g3.vue": [
		"drMB",
		0,
		35
	],
	"./cloudsim/roaming_free_wifi_g4pro": [
		"D5Up",
		0,
		33
	],
	"./cloudsim/roaming_free_wifi_g4pro.vue": [
		"D5Up",
		0,
		33
	],
	"./cloudsim/u2": [
		"NfNF",
		0,
		89
	],
	"./cloudsim/u2.vue": [
		"NfNF",
		0,
		89
	],
	"./cloudsim/why_glocalme_wifi": [
		"siYi",
		0,
		85
	],
	"./cloudsim/why_glocalme_wifi.vue": [
		"siYi",
		0,
		85
	],
	"./data_package": [
		"M3Kx",
		0,
		3
	],
	"./data_package.vue": [
		"M3Kx",
		0,
		3
	],
	"./data_package/area_package": [
		"fx7D",
		0,
		4
	],
	"./data_package/area_package.vue": [
		"fx7D",
		0,
		4
	],
	"./data_package/package_list": [
		"zTwn",
		0,
		69
	],
	"./data_package/package_list.vue": [
		"zTwn",
		0,
		69
	],
	"./data_package/payResult": [
		"tVYT",
		0,
		39
	],
	"./data_package/payResult.vue": [
		"tVYT",
		0,
		39
	],
	"./data_package/select_area": [
		"9OJo",
		0,
		19
	],
	"./data_package/select_area.vue": [
		"9OJo",
		0,
		19
	],
	"./data_package/select_destination": [
		"UkXV",
		0,
		96
	],
	"./data_package/select_destination.vue": [
		"UkXV",
		0,
		96
	],
	"./data_package/settlement": [
		"PyZp",
		0,
		23
	],
	"./data_package/settlement.vue": [
		"PyZp",
		0,
		23
	],
	"./glocalme/device_order_confirmation": [
		"YNn4",
		0,
		18
	],
	"./glocalme/device_order_confirmation.vue": [
		"YNn4",
		0,
		18
	],
	"./glocalme/device_order_payment": [
		"a4zJ",
		0,
		79
	],
	"./glocalme/device_order_payment.vue": [
		"a4zJ",
		0,
		79
	],
	"./glocalme/device_purchase": [
		"QgYi",
		0,
		47
	],
	"./glocalme/device_purchase.vue": [
		"QgYi",
		0,
		47
	],
	"./glocalme/orderResult": [
		"lVef",
		0,
		37
	],
	"./glocalme/orderResult.vue": [
		"lVef",
		0,
		37
	],
	"./glocalme/where_to_buy": [
		"8Jwm",
		0,
		17
	],
	"./glocalme/where_to_buy.vue": [
		"8Jwm",
		0,
		17
	],
	"./guide_byt": [
		"wJ3o",
		0,
		38
	],
	"./guide_byt.vue": [
		"wJ3o",
		0,
		38
	],
	"./home": [
		"26dS",
		0,
		36
	],
	"./home.vue": [
		"26dS",
		0,
		36
	],
	"./member/account copy": [
		"TE5r",
		0,
		15
	],
	"./member/account copy.vue": [
		"TE5r",
		0,
		15
	],
	"./member/account/cancel": [
		"D6Kw",
		0,
		59
	],
	"./member/account/cancel.vue": [
		"D6Kw",
		0,
		59
	],
	"./member/account/components/AccountLayout": [
		"8FnO",
		0
	],
	"./member/account/components/AccountLayout.vue": [
		"8FnO",
		0
	],
	"./member/account/components/MobileAccountLayout": [
		"v1Ih",
		0
	],
	"./member/account/components/MobileAccountLayout.vue": [
		"v1Ih",
		0
	],
	"./member/account/components/OrderDetail": [
		"cv71",
		0,
		45
	],
	"./member/account/components/OrderDetail.vue": [
		"cv71",
		0,
		45
	],
	"./member/account/components/OrderList": [
		"rrWC",
		0,
		88
	],
	"./member/account/components/OrderList.vue": [
		"rrWC",
		0,
		88
	],
	"./member/account/detail": [
		"E05m",
		0,
		30
	],
	"./member/account/detail.vue": [
		"E05m",
		0,
		30
	],
	"./member/account/list": [
		"02qJ",
		0,
		11
	],
	"./member/account/list.vue": [
		"02qJ",
		0,
		11
	],
	"./member/account/prompt": [
		"y+9r",
		0,
		46
	],
	"./member/account/prompt.vue": [
		"y+9r",
		0,
		46
	],
	"./member/account/setting": [
		"bFwZ",
		0,
		22
	],
	"./member/account/setting.vue": [
		"bFwZ",
		0,
		22
	],
	"./member/balanceDetails": [
		"PJPm",
		0,
		8
	],
	"./member/balanceDetails.vue": [
		"PJPm",
		0,
		8
	],
	"./member/equipmentManagement": [
		"+Dsh",
		0,
		9
	],
	"./member/equipmentManagement.vue": [
		"+Dsh",
		0,
		9
	],
	"./member/flowMall": [
		"Gh89",
		0,
		77
	],
	"./member/flowMall.vue": [
		"Gh89",
		0,
		77
	],
	"./member/flowMallDetail": [
		"8n8n",
		0
	],
	"./member/flowMallDetail.vue": [
		"8n8n",
		0
	],
	"./member/flowRecords": [
		"wAdl",
		0,
		16
	],
	"./member/flowRecords.vue": [
		"wAdl",
		0,
		16
	],
	"./member/layout": [
		"Sv/P",
		110
	],
	"./member/layout.vue": [
		"Sv/P",
		110
	],
	"./member/logout_notice": [
		"EMOH",
		0,
		48
	],
	"./member/logout_notice.vue": [
		"EMOH",
		0,
		48
	],
	"./member/modifyPassword": [
		"1NeY",
		0,
		61
	],
	"./member/modifyPassword.vue": [
		"1NeY",
		0,
		61
	],
	"./member/modify_information": [
		"sFQn",
		0,
		27
	],
	"./member/modify_information.vue": [
		"sFQn",
		0,
		27
	],
	"./member/myDeviceOrder": [
		"A36+",
		0,
		5
	],
	"./member/myDeviceOrder.vue": [
		"A36+",
		0,
		5
	],
	"./member/myDeviceOrderDetail": [
		"xw+A",
		0,
		14
	],
	"./member/myDeviceOrderDetail.vue": [
		"xw+A",
		0,
		14
	],
	"./member/myOrder": [
		"F6dv",
		0,
		86
	],
	"./member/myOrder.vue": [
		"F6dv",
		0,
		86
	],
	"./member/productBalanceDetails": [
		"BrLK",
		0,
		21
	],
	"./member/productBalanceDetails.vue": [
		"BrLK",
		0,
		21
	],
	"./member/seviceComponent/actionsheetModal": [
		"3XCi",
		68
	],
	"./member/seviceComponent/actionsheetModal.vue": [
		"3XCi",
		68
	],
	"./member/seviceComponent/flowRecordList": [
		"Y1il",
		53
	],
	"./member/seviceComponent/flowRecordList.vue": [
		"Y1il",
		53
	],
	"./old_select": [
		"zRPu",
		0,
		84
	],
	"./old_select.vue": [
		"zRPu",
		0,
		84
	],
	"./register/active_account": [
		"TKm5",
		0,
		62
	],
	"./register/active_account.vue": [
		"TKm5",
		0,
		62
	],
	"./register/active_account_suc": [
		"BgGu",
		0,
		58
	],
	"./register/active_account_suc.vue": [
		"BgGu",
		0,
		58
	],
	"./register/agreement": [
		"vznc",
		0,
		109
	],
	"./register/agreement.vue": [
		"vznc",
		0,
		109
	],
	"./register/email": [
		"E+yX",
		0,
		7
	],
	"./register/email.vue": [
		"E+yX",
		0,
		7
	],
	"./register/mobilephone": [
		"VlOA",
		0,
		20
	],
	"./register/mobilephone.vue": [
		"VlOA",
		0,
		20
	],
	"./register/phone_code": [
		"AJUW",
		0,
		28
	],
	"./register/phone_code.vue": [
		"AJUW",
		0,
		28
	],
	"./register/privacy_policy": [
		"rAiP",
		0,
		108
	],
	"./register/privacy_policy.vue": [
		"rAiP",
		0,
		108
	],
	"./register/register_email": [
		"zBns",
		0,
		72
	],
	"./register/register_email.vue": [
		"zBns",
		0,
		72
	],
	"./register/register_phone": [
		"I4nI",
		0,
		52
	],
	"./register/register_phone.vue": [
		"I4nI",
		0,
		52
	],
	"./register/search_area": [
		"8S4f",
		0,
		87
	],
	"./register/search_area.vue": [
		"8S4f",
		0,
		87
	],
	"./register/select_area": [
		"K8MG",
		0,
		92
	],
	"./register/select_area.vue": [
		"K8MG",
		0,
		92
	],
	"./register/set_password": [
		"yCRL",
		0,
		65
	],
	"./register/set_password.vue": [
		"yCRL",
		0,
		65
	],
	"./service/coverage": [
		"4iBc",
		0,
		83
	],
	"./service/coverage.vue": [
		"4iBc",
		0,
		83
	],
	"./service/enterprise": [
		"t2hf",
		0,
		42
	],
	"./service/enterprise.vue": [
		"t2hf",
		0,
		42
	],
	"./service/faq": [
		"X/ut",
		0,
		13
	],
	"./service/faq.vue": [
		"X/ut",
		0,
		13
	],
	"./service/faq_detail": [
		"FtJy",
		0,
		97
	],
	"./service/faq_detail.vue": [
		"FtJy",
		0,
		97
	],
	"./service/faq_list": [
		"Mq6G",
		0,
		54
	],
	"./service/faq_list.vue": [
		"Mq6G",
		0,
		54
	],
	"./service/maintenance": [
		"pNlR",
		0,
		66
	],
	"./service/maintenance.vue": [
		"pNlR",
		0,
		66
	],
	"./service/manual": [
		"epJN",
		0,
		10
	],
	"./service/manual.vue": [
		"epJN",
		0,
		10
	],
	"./service/manual_detail": [
		"gCD1",
		0,
		82
	],
	"./service/manual_detail.vue": [
		"gCD1",
		0,
		82
	],
	"./service/manual_list": [
		"WPnz",
		0,
		57
	],
	"./service/manual_list.vue": [
		"WPnz",
		0,
		57
	],
	"./service/safety_measures": [
		"lhkk",
		0,
		76
	],
	"./service/safety_measures.vue": [
		"lhkk",
		0,
		76
	],
	"./service/support": [
		"/R+I",
		43
	],
	"./service/support.vue": [
		"/R+I",
		43
	],
	"./simbox/common_simbox": [
		"V3If",
		0,
		55
	],
	"./simbox/common_simbox.vue": [
		"V3If",
		0,
		55
	],
	"./simbox/poster": [
		"NnDx",
		0,
		78
	],
	"./simbox/poster.vue": [
		"NnDx",
		0,
		78
	],
	"./us_mall/home": [
		"rPw1",
		0,
		1
	],
	"./us_mall/home/": [
		"rPw1",
		0,
		1
	],
	"./us_mall/home/index": [
		"rPw1",
		0,
		1
	],
	"./us_mall/home/index.vue": [
		"rPw1",
		0,
		1
	],
	"./us_mall/home/product_detail": [
		"s9i0",
		0,
		50
	],
	"./us_mall/home/product_detail.vue": [
		"s9i0",
		0,
		50
	],
	"./us_mall/how/how_index": [
		"R6Px",
		0,
		107
	],
	"./us_mall/how/how_index.vue": [
		"R6Px",
		0,
		107
	],
	"./us_mall/layout": [
		"twVj",
		106
	],
	"./us_mall/layout.vue": [
		"twVj",
		106
	],
	"./us_mall/mall/cart": [
		"uAXh",
		0,
		105
	],
	"./us_mall/mall/cart.vue": [
		"uAXh",
		0,
		105
	],
	"./us_mall/mall/product_choose": [
		"x45Q",
		0,
		104
	],
	"./us_mall/mall/product_choose.vue": [
		"x45Q",
		0,
		104
	],
	"./us_mall/order/orderSuccess": [
		"dQuU",
		0,
		103
	],
	"./us_mall/order/orderSuccess.vue": [
		"dQuU",
		0,
		103
	],
	"./us_mall/order/order_cancel": [
		"RKiO",
		0,
		102
	],
	"./us_mall/order/order_cancel.vue": [
		"RKiO",
		0,
		102
	],
	"./us_mall/order/order_canceled": [
		"G4KS",
		0,
		101
	],
	"./us_mall/order/order_canceled.vue": [
		"G4KS",
		0,
		101
	],
	"./us_mall/order/order_settlement": [
		"GerU",
		0,
		34
	],
	"./us_mall/order/order_settlement.vue": [
		"GerU",
		0,
		34
	],
	"./us_mall/order/paymentPage": [
		"BDhm",
		0,
		91
	],
	"./us_mall/order/paymentPage.vue": [
		"BDhm",
		0,
		91
	],
	"./us_mall/order/repayments": [
		"cbF8",
		0,
		40
	],
	"./us_mall/order/repayments.vue": [
		"cbF8",
		0,
		40
	],
	"./us_mall/order/return_apply": [
		"o8Dn",
		0,
		100
	],
	"./us_mall/order/return_apply.vue": [
		"o8Dn",
		0,
		100
	],
	"./us_mall/order/return_suc": [
		"vZb2",
		0,
		99
	],
	"./us_mall/order/return_suc.vue": [
		"vZb2",
		0,
		99
	],
	"./us_mall/service": [
		"wJdI",
		0,
		2
	],
	"./us_mall/service/": [
		"wJdI",
		0,
		2
	],
	"./us_mall/service/about": [
		"IBF+",
		0,
		24
	],
	"./us_mall/service/about.vue": [
		"IBF+",
		0,
		24
	],
	"./us_mall/service/contact_us": [
		"QLMm",
		0,
		94
	],
	"./us_mall/service/contact_us.vue": [
		"QLMm",
		0,
		94
	],
	"./us_mall/service/cooperation": [
		"PdnF",
		0,
		98
	],
	"./us_mall/service/cooperation.vue": [
		"PdnF",
		0,
		98
	],
	"./us_mall/service/faq": [
		"Jw9y",
		0,
		80
	],
	"./us_mall/service/faq.vue": [
		"Jw9y",
		0,
		80
	],
	"./us_mall/service/index": [
		"wJdI",
		0,
		2
	],
	"./us_mall/service/index.vue": [
		"wJdI",
		0,
		2
	],
	"./us_mall/service/policy": [
		"qux5",
		0,
		64
	],
	"./us_mall/service/policy.vue": [
		"qux5",
		0,
		64
	],
	"./users/forgot_password": [
		"srdE",
		0,
		25
	],
	"./users/forgot_password.vue": [
		"srdE",
		0,
		25
	],
	"./users/forgot_password_email": [
		"uACL",
		0,
		6
	],
	"./users/forgot_password_email.vue": [
		"uACL",
		0,
		6
	],
	"./users/login": [
		"15O4",
		0,
		12
	],
	"./users/login.vue": [
		"15O4",
		0,
		12
	],
	"./users/login_email": [
		"ioPs",
		0,
		44
	],
	"./users/login_email.vue": [
		"ioPs",
		0,
		44
	],
	"./users/login_phone": [
		"rpsR",
		0,
		95
	],
	"./users/login_phone.vue": [
		"rpsR",
		0,
		95
	],
	"./users/phone_code": [
		"MjZ1",
		0,
		29
	],
	"./users/phone_code.vue": [
		"MjZ1",
		0,
		29
	],
	"./users/reset_email": [
		"uQ+y",
		0,
		90
	],
	"./users/reset_email.vue": [
		"uQ+y",
		0,
		90
	],
	"./users/reset_password": [
		"lU8q",
		0,
		73
	],
	"./users/reset_password.vue": [
		"lU8q",
		0,
		73
	],
	"./users/reset_password_suc": [
		"aZCW",
		0,
		70
	],
	"./users/reset_password_suc.vue": [
		"aZCW",
		0,
		70
	],
	"./users/retrieve_pwd_email": [
		"4aAe",
		0,
		75
	],
	"./users/retrieve_pwd_email.vue": [
		"4aAe",
		0,
		75
	],
	"./users/retrieve_pwd_phone": [
		"ENmQ",
		0,
		81
	],
	"./users/retrieve_pwd_phone.vue": [
		"ENmQ",
		0,
		81
	],
	"./users/top_up": [
		"kRtp",
		0,
		49
	],
	"./users/top_up.vue": [
		"kRtp",
		0,
		49
	],
	"./worldphone/common_phone": [
		"pXci",
		0,
		93
	],
	"./worldphone/common_phone.vue": [
		"pXci",
		0,
		93
	],
	"./worldphone/p3": [
		"kpm9",
		0,
		67
	],
	"./worldphone/p3.vue": [
		"kpm9",
		0,
		67
	],
	"./worldphone/s1": [
		"aHl1",
		0,
		32
	],
	"./worldphone/s1.vue": [
		"aHl1",
		0,
		32
	],
	"./worldphone/s20i": [
		"48vX",
		0,
		56
	],
	"./worldphone/s20i.vue": [
		"48vX",
		0,
		56
	],
	"./worldphone/why_glocalme_world_phone": [
		"xxrX",
		0,
		51
	],
	"./worldphone/why_glocalme_world_phone.vue": [
		"xxrX",
		0,
		51
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "N4h9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/***
 * module naming rule
 * @Description Chinese language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "common": {
        "submit": "提交",
        "defaultInput": "请输入",
        "cancel": "取消",
        "confirm": "确认",
        "loginTimeout": "未登录或者登录超时，请重新登录",
        "noData": "没有数据",
        "custom": "在线客服"
    },
    "member_account": {
        "balance": "余额",
        "recharge": "充值",
        "flowHistory": "流量历史",
        "purchaseRecord": "购买记录",
        "myData": "我的流量",
        "deviceManagement": "设备管理",
        "changePsd": "修改密码",
        "logout": "注销",
        "acBalance": "我的余额",
        "acFlow": "我的流量",
        "acDevice": "我的设备",
        "acOrder": "购买记录",
        "acDeviceOrder": "设备订单",
        "acFlowStatistics": "流量统计",
        "acSetting": "设置",
        "balanceInfo": "当前余额",
        "rechargeCode": "充值码",
        "enterRechargeCode": "请输入充值码",
        "gift": "赠送",
        "returnAccount": "退款至【我的余额】",
        "certification": "已认证",
        "noCertified": "未认证"
    },
    "modify_information": {
        "account": "账号",
        "name": "姓名",
        "identification": "证件号",
        "countryName": "常住地区",
        "id": "身份信息",
        "edit": "编辑",
        "complete": "完成",
        "placeholderFirstName": "请输入您的姓氏",
        "placeholderName": "请输入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "请输入您的身份证/VISA卡/驾驶号",
        "isNull": "未填写",
        "onlyNumber": "只能输入数字或字母",
        "IDTip": "证件号只能输入数字或字母"
    },
    "member_modifyPassword": {
        "oldPsd": "旧密码",
        "newPsd": "新密码",
        "title": "修改密码",
        "submit": "修改密码",
        "setUp": "设置",
        "accountSetUp": "账户设置",
        "accountManage": "账户管理",
        "password": "密码",
        "forgetPassword": "忘记密码",
        "loginOut": "退出登录",
        "unsubscribe": "注销账户",
        "unsubscribeAfter": "账户注销后，您将放弃以下权益",
        "tip1": "通过活动赠送、代充值及充值码兑换的余额",
        "tip2": "未用完及赠送的流量套餐",
        "tip3": "注销前，请认真阅读",
        "ucloudlink": "《优克联账户注销须知》",
        "cancellation": "联系客服注销",
        "oldPsdNull": "旧密码不能为空",
        "newPsdNull": "新密码不能为空",
        "modifyPasswordSuccess": "修改密码成功"
    },
    "member_myDeviceOrder": {
        "title": "设备订单",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消订单"
        },
        "pending": "Pending Payment",
        "noData": "暂无设备订单，请到商店看看~",
        "noList": "没有数据~",
        "tryAgainLater": "请稍后再试"
    },
    "member_recharge": {
        "recharge": "充值",
        "rechargeAmount": "（选择充值金额）",
        "present": "赠送",
        "currentBalance": "当前余额",
        "payAmount": "充值金额",
        "unit": "¥",
        "pay": "确认支付",
        "alipay": "支付宝",
        "paypal": "PayPal",
        "operateMess": "操作提示",
        "giveMore": "赠送"
    },
    "member_equipmentManagement": {
        "noData": "没有设备？",
        "knowMore": "去了解一下",
        "bindDevice": "绑定设备",
        "placeholderIMEI": "请输入设备IMEI号",
        "placeholderPwd": "请输入设备初始PWD",
        "bindNow": "立即绑定",
        "myEquipment": "我的设备",
        "equipmentMunual": "设备手册",
        "dataBound": "解除绑定",
        "bindSuccess": "绑定成功",
        "unBindSuccess": "解绑成功",
        "imeiNull": "设备IMEI不能为空",
        "pwdNull": "设备初始PWD不能为空"
    },
    "member_flowRecords": {
        "record": "流量历史",
        "filter": "筛选",
        "trafficStatistics": "流量统计"
    },
    "member_balanceDetails": {
        "title": "购买记录",
        "filter": "筛选",
        "total": "合计",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消订单"
        }
    },
    "member_productBalanceDetails": {
        "remain": "剩余可用流量",
        "validTime": "有效时间",
        "coverage": "覆盖范围",
        "productIntro": "套餐描述",
        "buyTime": "购买时间",
        "unsubscribe": "退订",
        "buyTimeTips": "以上时间基于中国北京时间（GMT+8）",
        "unsubscribeTips": "退订成功，本次消费金额将退到我的余额里"
    },
    "users_login": {
        "loginPhone": "手机登录",
        "loginEmail": "邮箱登录",
        "register": "账号注册",
        "inputPhone": "请输入手机号码",
        "inputPassword": "请输入密码",
        "forgetPassword": "忘记密码",
        "login": "登录",
        "goToLogin": "去登录",
        "inputEmail": "请输入邮箱号",
        "smsCode": "短信验证码",
        "inputSMSCode": "请输入短信验证码",
        "noReceiveCode": "没收到验证码？",
        "resend": "重新发送",
        "nextStep": "下一步",
        "findByPhone": "通过手机找回",
        "findByEmail": "通过邮箱找回",
        "verifyByEmail": "请到邮箱验证",
        "sendEmailTo": "我们已发送一封电子邮件到",
        "findYourPassword": "请点击其中的链接，并按步骤操作来找回您的密码",
        "noReceiveEmail": "收不到邮件？请检查您的垃圾邮件和已删除邮件目录下是否有来自 glocalme@ucloudlink.com 的邮件。",
        "or": "或",
        "resetPassword": "重设密码",
        "oldFormat": "至少6个字符",
        "passwordFormat": "6-20个字符(字母、数字或符号的组合)",
        "completeLogin": "完成并登录",
        "resetPasswordSuc": "重设密码成功",
        "backToGlocalMe": "请回到 GlocalMe Connect 登录体验",
        "activeReminder": "账户未激活，请前往该邮箱，点击激活链接来完成您的账户注册。",
        "known": "知道了"
    },
    "users_register": {
        "registerPhone": "手机注册",
        "registerEmail": "邮箱注册",
        "hasAccount": "已有账号？",
        "agree": "我同意",
        "agreement": "用户协议",
        "and": "和",
        "policy": "隐私政策",
        "logoutNotice": "永久注销",
        "submit": "提交",
        "selectArea": "选择常住地区",
        "countryOrRegion": "国家/地区",
        "change": "更换",
        "defaultRegion": "中国内地",
        "AE": "阿拉伯联合酋长国",
        "search": "搜索热门国家/地区",
        "reminder": "温馨提示",
        "reminderTips": "选择【",
        "reminderTips2": "】作为常住地，可享受该地及周边的专享优惠。选定后将不可更改。确定选择吗？",
        "confirm": "确定",
        "cancel": "取消",
        "setPassword": "设置密码",
        "registerByEmail": "请点击其中的链接来完成您的账户注册。",
        "activeSuc": "激活成功",
        "activeing": "正在激活",
        "activeAgain": "再次激活",
        "activeFail": "激活失败",
        "verified": "我已验证",
        "registerSuccess": "注册成功"
    },
    "home": {
        "globalPackageCN": "全球畅享套餐",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "全球过百个合作伙伴",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "由于系统服务升级，您需要选择常住国家或地区后方可继续使用。",
        "reminderTips": "选择【",
        "reminderTips2": "】作为常住地，可享受我们即将为该地及周边推出的专享优惠；且账户余额将",
        "reminderTips3": "按汇率【",
        "reminderTips4": "】",
        "reminderTips5": "转换为【",
        "reminderTips6": "】显示。选定后将不可更改。确定选择吗？",
        "gotoPC": "电脑版"
    },
    "privacyPolicy": {
        "changeDate": "隐私条款变更公告",
        "changeContain": "我们的隐私条款已更新。",
        "changeContain2": "我们非常重视您的隐私。因此我们制定了涵盖如何收集、使用、披露、转让以及存储您的信息的隐私政策。我们不会向任何第三方提供您的信息，除非得到您的授权。若我们将信息用于您未授权用途或目的，我们会事先再次征求您的同意。",
        "changeContain3": "您可以阅读我们完整的<a href=\"/users/agreement\" target=\"_blank\">《用户协议》</a>和<a href=\"/users/privacy_policy\" target=\"_blank\">《隐私条款》</a>了解我们的承诺。",
        "noagree": "不同意",
        "agree": "同意"
    },
    "service": {
        "selectDevice": "选择设备",
        "company": "企业方案",
        "faqs": "常见问题",
        "afterSale": "售后政策",
        "manual": "操作手册",
        "safety": "安全措施",
        "coverage": "覆盖区域"
    },
    "purchase": {
        "buy": "购买",
        "online": "线上渠道",
        "offline": "线下门店",
        "distributor": "分销商",
        "shopAddress": "店铺地址",
        "shopTels": "联系电话"
    },
    "data_package": {
        "flowShop": "流量商城",
        "recommend": "为您推荐",
        "destination": "选择目的地",
        "searchDestination": "搜索目的地",
        "historySearch": "历史搜索",
        "clean": "清空",
        "more": "更多",
        "enjoyPackage": "畅享包",
        "commonPackage": "普通包",
        "include": "含",
        "areaPackage": "的跨区域包",
        "enjoyDay": "包天畅享",
        "enjoyMonth": "月畅享",
        "unlimited": "无限",
        "houxiansu": "后限速",
        "currentMonth": "当月失效",
        "currentDay": "当日失效",
        "immediately": "立即生效",
        "morrow": "次日生效",
        "nextMonth": "次月生效",
        "iDay": "天",
        "iDays": "天",
        "iMonth": "个月",
        "iMonths": "个月",
        "cxtcIMonth": "月",
        "antarctica": "热门",
        "asia": "亚洲",
        "european": "欧洲",
        "africa": "非洲",
        "northAmerica": "美洲",
        "southAmerica": "南美洲",
        "oceania": "大洋洲",
        "flow": "流量",
        "period": "有效期",
        "applicableArea": "适用区域",
        "useNotice": "使用须知",
        "cost": "需付金额",
        "order": "订购",
        "confirmPay": "确认支付",
        "infiniteFlow": "无限流量",
        "unsubscribe": "不可退订",
        "subscribe": "可退订",
        "payFailed": "支付失败",
        "paypalTips": "由于PayPal的认证机制，PayPal付款的信息可能会出现延迟"
    },
    "pay_result": {
        "orderSuccess": "订购成功",
        "chargeSuccess": "充值成功",
        "orderSucTips": "您购买的[ ",
        "orderSucTips2": " ]将在1分钟内到账，如长时间未到账，请咨询客服。",
        "orderSucTips3": "将在1分钟内到账，如长时间未到账，请咨询客服。",
        "packageName": "套餐名称",
        "chargeAmount": "充值金额",
        "payAmount": "支付金额",
        "back": "返回首页",
        "myFlow": "查看我的流量",
        "myBalance": "查看我的余额",
        "tryLater": "请稍后再试",
        "succeed": "已完成支付",
        "fail": "支付遇到问题，请重新下单",
        "backToShop": "回到商城首页",
        "successful": "交易成功",
        "rejected": "交易被拒绝，请联系您的银行",
        "unsuccessful": "交易失败，请重试",
        "referenceNumber": "订单编号"
    },
    "my_order": {
        "month": "月",
        "day": "日"
    },
    "member_myFlow": {
        "myFlow": "我的流量",
        "remainHighSpeedTraffic": "剩余高速",
        "validityPeriod": "有效期",
        "day": "天",
        "month": "月",
        "status": "状态",
        "invalidPackage": "失效套餐",
        "usageRule": "使用规则",
        "close": "收起",
        "queryInvalidPackage": "查看失效套餐",
        "mccList": "适用区域",
        "usageMess": "使用须知",
        "payAmount": "支付金额",
        "payTime": "购买时间",
        "effectiveTime": "有效时间",
        "validTime": "生效时间",
        "invalidTime": "失效时间",
        "flow": "流量",
        "remainingFlow": "剩余流量",
        "highSpeedTraffic": "高速流量",
        "remainHighSpeedTraffics": "剩余高速流量",
        "unsubscribe": "退订",
        "unsubscribed": "已退订",
        "isCancelPackage": "是否退订该套餐?",
        "actionTip1": "注：使用PayPal支付的订单会收取",
        "actionTip2": " 手续费用",
        "reBack": "退款至【我的余额】",
        "cancel": "取消",
        "cancelSuccess": "退订成功",
        "reBackBy": "退款已退至【我的余额】",
        "iKnow": "我知道了",
        "usageRule1": "畅享包优先使用",
        "usageRule2": "相同类型可用流量包默认按购买时间顺序使用",
        "usageRule3": "若畅享包高速流量用完，将自动切换普通包使用",
        "packageUsageRule": "套餐使用规则",
        "dicObj": {
            "notActivated": "未激活",
            "inUsing": "使用中",
            "useEnd": "已用完",
            "expire": "到期",
            "transfer": "已转移",
            "unsubscribe": "退订",
            "valid": "有效",
            "invalid": "无效",
            "currentMonth": "当月失效"
        },
        "to": " 至 ",
        "noData": "暂无流量套餐，请到商店看看~",
        "noList": "没有数据~",
        "accumulatedThisHour": "本小时累计",
        "accumulatedThisDay": "本天累计",
        "accumulatedThisMonth": "本月累计",
        "accumulatedThisYear": "本年累计",
        "accumulatedFlow": "累计流量",
        "flowDetail": "流量详情"
    },
    "select_area": {
        "destination": "选择目的地",
        "selectCountry": "选择热门国家/地区"
    },
    "footer": {
        "belongs": "您的账号属于",
        "comeTo": "您已来到",
        "site": "站点",
        "changeTips": "您的账号无法切换至其他站点",
        "changeTips2": "如需切换，请您注销登录",
        "switchWebsite": "您现在访问其他站点与您账号归属站点不一致，需要注销登录才能继续访问"
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside 是 uCloudlink 创新推出的全球数据流量服务，通过内置 GlocalMe Connect APP于手机，用户即可享受由 CloudSIM 技术所带来的前所未有的数据连接体验。",
            "title1": "使用便捷",
            "content1": "得益于GlocalMe® Inside服务的全球覆盖，商旅人士可以便捷无忧地享用移动数据。",
            "title2": "智能选网",
            "content2": "GlocalMe® Inside的智能选网功能实时监测信号变化，弃劣择优，随时保证连接至优质的本地网络。",
            "title3": "本地资费",
            "content3": "GlocalMe® Inside与超过100个国家及地区建立了运营商合作伙伴关系，因而能够为用户带来公平的本地数据资费。",
            "title4": "信息安全",
            "content4": "相较公共Wi-Fi，GlocalMe® Inside的连接为用户提供了更高的安全与隐私保护。",
            "title5": "GlocalMe® Inside世界手机一机在手，通行全球"
        },
        "u2": {
            "title": '时尚之选U2',
            "title1_1": "一机在手 全球通行",
            "title1_2": "GlocalMe U2",
            "title2": "U2超舒适的握持感",
            "title3_1": "香槟金",
            "title3_2": "寒铁灰",
            "title4": "时尚轻薄 便于携带",
            "title5": "随时随地 畅想4G网络",
            "title6": "基本参数",
            "title7_1": "覆盖100+国家及地区",
            "title7_2": "GlocalMe零漫游上网服务覆盖5大洲，100多个国际及地区",
            "title7_3": "全球Wi-Fi随时随地，任性联网。"
        },
        "g3": {
            "title1_1": "漫游小怪兽",
            "title1_2": "GlocalMe全新旗舰G3",
            "title2_1": "出国旅游必备全球上网神器",
            "title3_1": "黑·寒铁灰边框",
            "title3_2": "白·香槟金边框",
            "title4_1": "覆盖100+国家及地区",
            "title4_2": "GlocalMe零漫游上网服务覆盖5大洲，100多个热门国家及地区",
            "title4_3": "无需插入SIM卡，随时随地，任性联网",
            "title4_4": "详见官网“覆盖区域”",
            "title5_1": "为你充电 上网不掉线",
            "title5_2": "电量可输出，为手机等终端设备充电",
            "title5_3": "5350mAh锂离子电池，续航长达15小时",
            "title5_4": "采用国际一线厂商一流电芯，安全有保障",
            "title6_1": "零漫游,畅享全球最优网络",
            "title6_2": "业内领先的云SIM卡技术 实时智能匹配当地最优网络",
            "title7_1": "有分享 才更快乐",
            "title7_2": "您的Wi-Fi可支持5人同时上网，智能手机、iPad、笔记本、可穿戴智能设备等均能连接使用",
            "title8_1": "APP管理 更高效",
            "title8_2": "可以通过APP随时随地查询流量、续费充值、购买套餐、修改个人信息；支付方式：微信支付、支付宝、银联支付、PayPal",
            "title8_3": "长按图片识别二维码下载APP",
            "title9_1": "4G网速，资费更灵活",
            "title9_2": "按流量收费:",
            "title9_3": "计费0.05€/MB，10€封顶，限速不限流量",
            "title9_4": "套餐收费:",
            "title9_5": "私人定制，流量计费更省心，详见流量商城",
            "title9_6": "数据更安全",
            "title9_7": "私人专属移动热点, 保护您的信息安全,",
            "title9_8": "防止掉入免费Wi-Fi的黑洞"
        },
        "p3": {
            "title1_1": "多彩生活，一定有一个属于你的颜色",
            "title1_2": "创新跟和谐并重的设计。源自对产品形状，材料与颜色的同步研发，各元素之间的彼此呼应，一同创造出类拔萃，意义非凡的智能手机",
            "title3": "通过CloudSIM技术实现，不再需要漫游和SIM卡。",
            "title4": "你和他们之间的距离只差\"我\"",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "创新的全球数据流量服务，通过内置的GlocalMe® Connect APP，用户即可享受由CloudSIM技术带来的前所未有的数据连接体验",
            "title6_1": "等等，还有更多！",
            "title6_2": "我们服务包括"
        },
        "simbox": {
            "title": "多卡宝",
            "title1": "手机秒变多卡多待",
            "title2": "15大优势满足多卡管理需求",
            "title3": "让手机秒变多卡多待",
            "title4": "国际通话 0漫游费",
            "title5": "真4G，全网通",
            "title6_1": "7x24小时在线",
            "title6_2": "电话/短信不漏接",
            "title7": "方正精致，简约时尚"
        },
        "glocalme_wifi": {
            "title": "为什么选择GlocalMe Wi-Fi"
        },
        "glocalme_phone": {
            "title": "为什么选择GlocalMe世界机"
        }
    },
    "about": {
        "contact": "联系我们",
        "news": "新闻动态",
        "glocalme": "关于我们",
        "partnership": "寻求合作",
        "partnerships": "合作伙伴",
        "note": "为了让我们更了解您的合作意向，请填以下表格，我们会尽快与阁下联系！",
        "username": "姓名",
        "email": "邮箱",
        "company": "公司名称",
        "position": "职位",
        "phone": "电话",
        "demand": "详情",
        "success": "成功",
        "deviceType": "设备类型",
        "quantity": "产品数量",
        "address": "地址",
        "heard": "如何知道我们？",
        "agreement": "同意<a href=\"/users/privacy_policy\">《隐私政策》</a>和<a href=\"/users/agreement\">《用户协议》</a>，uCloudlink 将会通过电子邮件或手机号码与您取得联系"
    },
    "validate": {
        "isEmail": "邮箱格式",
        "isMobilePhone": "手机号码",
        "isChinaName": "中文姓名",
        "required": "必填哦",
        "format": "格式不对哦~",
        "min": "最少应该输入",
        "max": "最多可以输入",
        "char": "个字符哦",
        "equal": "输入不一致",
        "invalid": "您的输入含有非法字符，如 <>, >< 等",
        "digits": "产品数量 5-100"
    },
    "newCreate": {
        "onlyForAE": "此设备仅常住地为阿联酋的用户使用",
        "purchaseTips": "此页面只提供英文内容"
    }
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _fastclick = __webpack_require__("v5o6");

var _fastclick2 = _interopRequireDefault(_fastclick);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

__webpack_require__("erWL");

var _lang = __webpack_require__("cEaa");

var _lang2 = _interopRequireDefault(_lang);

var _inject = __webpack_require__("tVOT");

var _inject2 = _interopRequireDefault(_inject);

var _common = __webpack_require__("WBBB");

var _common2 = _interopRequireDefault(_common);

var _index = __webpack_require__("3BeM");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("NXWw");

var _index4 = _interopRequireDefault(_index3);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _eventLib = __webpack_require__("5DhB");

var _eventLib2 = _interopRequireDefault(_eventLib);

var _filters = __webpack_require__("V1NV");

var _filters2 = _interopRequireDefault(_filters);

var _statusBus = __webpack_require__("A62N");

var _statusBus2 = _interopRequireDefault(_statusBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_inject2.default, {});
_vue2.default.use(_index2.default);
_vue2.default.use(_index4.default);

(0, _keys2.default)(_filters2.default).forEach(function (key) {
  _vue2.default.filter(key, _filters2.default[key]);
});

var canSite_switch = _jsCookie2.default.get('site_switch');
if (!canSite_switch) {
  _eventLib2.default.once('initAppConfig', function (appConfig) {
    var E_INIT_MVNO = 'eventInitMvno';

    var proto = _vue2.default.prototype;
    proto.commonHelper = (0, _common2.default)(appConfig);
    _vue2.default.mixin({
      methods: {
        apiReady: function apiReady() {}
      },
      created: function created() {
        var _this = this;

        if (proto.mvno) {
          this.apiReady();
        } else {
          _eventLib2.default.once(E_INIT_MVNO, function () {
            _this.apiReady();
          });
        }
      }
    });
    _jsCookie2.default.set("language", "zh-CN", { expires: 1, domain: "." + location.hostname });
    var mvno = proto.mvno = staticData.getMvnoCode;

    _vue2.default.prototype.ObjectMvno = mvno;
    _eventLib2.default.emit(E_INIT_MVNO, mvno);
    app_init();
    function app_init() {
      var lang = _jsCookie2.default.get("language");

      if (lang === "zh-CN") {
        _lang2.default.locale = 'zh';
      } else if (lang === "zh-TW" || lang === "zh-HK") {
        _lang2.default.locale = 'tw';
      } else if (lang === "en-US") {
        _lang2.default.locale = 'en';
      } else {

        _lang2.default.locale = 'en';
      }
      initRouter();
    }
  });
}

function initRouter() {
  var Router = new _vueRouter2.default((0, _extends3.default)({}, _router2.default, {
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 };
    }
  }));

  function getParams(str1, pagePath) {
    var obj = {};
    if (typeof str1 === 'string') {
      var arrPagePath = void 0,
          reg = new RegExp(str1);
      arrPagePath = pagePath.split("/");
      for (var i = 0; i < arrPagePath.length; i++) {
        if (reg.test(arrPagePath[i])) {
          obj[str1] = decodeURIComponent(arrPagePath[i].substring(str1.length + 1));
        }
      }
    }
    return obj;
  }

  Router.beforeEach(function (to, from, next) {
    var reg = /\/users\/login/,
        flag = false;
    if (reg.test(to.path)) {
      // 匹配登录页路由
      return next();
    } else {
      to.matched.forEach(function (items) {
        if (items.meta && items.meta.requiresAuth === true) {
          flag = true;
          return false;
        }
      });
      if (flag && !_vue2.default.prototype.cookieHelper.get("access_token")) {
        return next({
          path: "/users/login",
          query: {
            returnUrl: to.path
          }
        });
      } else {
        var reg1 = /\/data_package\/settlement/;
        if (reg1.test(to.redirectedFrom)) {
          var param1 = getParams('goodsCode', to.redirectedFrom);
          var param2 = getParams('categoryCode', to.redirectedFrom);
          if (param2.categoryCode) {
            return next({ path: "/data_package/settlement?goodsCode=" + param1.goodsCode + "&categoryCode=" + param2.categoryCode.replace(/\?/g, "&") });
          } else {
            return next({ path: "/data_package/settlement?goodsCode=" + param1.goodsCode.replace(/\?/g, "&") });
          }
        }

        next();
      }
    }
    if (from.path === to.path) return;
  });

  Router.afterEach(function (to) {
    if (to.query && to.query.openid) {
      localStorage.setItem("openid", to.query.openid);
    }

    try {
      var fn_str = staticData.thirdPartyCode.mobile.thirdPartyFn;
      var f = new Function('to', fn_str);
      f(to);
    } catch (e) {
      console.log(e);
    }
  });

  var thisApp = new _vue2.default({
    router: Router,
    i18n: _lang2.default,
    render: function render(h) {
      return h(_App2.default);
    }
  }).$mount('#app-box');

  _eventLib2.default.on('loginTimeout', function () {

    onHide();
  });
  function onHide() {
    if (thisApp.$route.query && thisApp.$route.query.returnUrl) {
      thisApp.$router.push({ path: '/', query: { returnUrl: thisApp.$route.query.returnUrl } });
    } else {
      thisApp.$router.push({ path: '/', query: { returnUrl: thisApp.$route.fullPath } });
    }
  }
}
_vue2.default.prototype.cookieHelper = _jsCookie2.default;
_vue2.default.prototype.NotInterceptors = false;

_vue2.default.config.productionTip = false;

if (location.search.indexOf('_render=1') !== -1) {
  var timeout = location.search.match(/tit=(\d+)/);
  if (timeout) timeout = Number(timeout[1]) || 7000;else timeout = 7000;
  setTimeout(function () {
    window.name = document.documentElement.outerHTML;
  }, timeout);
}

/***/ }),

/***/ "NeJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORne":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QaSf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lvsiyuan-young on 2020/06/10.
 * 语言包
 */
var folderFile = {};
var readfolder = __webpack_require__("a16M");

readfolder.keys().map(function (key) {
  var folder = key.split("/")[1];
  folderFile[folder] = (0, _extends3.default)({}, folderFile[folder], readfolder(key)["default"]);
});

exports.default = folderFile;

/***/ }),

/***/ "RFS8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/***
 * module naming rule
 * @Description TW language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "common": {
        "submit": "提交",
        "defaultInput": "請輸入",
        "cancel": "取消",
        "confirm": "確認",
        "loginTimeout": "未登錄或者登錄超時，請重新登錄",
        "noData": "沒有資料",
        "custom": "在線客服"
    },
    "member_account": {
        "balance": "餘額",
        "recharge": "充值",
        "flowHistory": "流量歷史",
        "purchaseRecord": "購買記錄",
        "myData": "我的流量",
        "deviceManagement": "設備管理",
        "changePsd": "修改密碼",
        "logout": "登出",
        "acBalance": "我的餘額",
        "acFlow": "我的流量",
        "acDevice": "我的設備",
        "acOrder": "購買記錄",
        "acDeviceOrder": "設備訂單",
        "acFlowStatistics": "流量統計",
        "acSetting": "設置",
        "balanceInfo": "當前餘額",
        "rechargeCode": "充值碼",
        "enterRechargeCode": "請輸入充值碼",
        "gift": "贈送",
        "returnAccount": "退款至【我的餘額】",
        "certification": "已認證",
        "noCertified": "未認證"
    },
    "modify_information": {
        "account": "帳戶",
        "name": "姓名",
        "identification": "護照/身份證號碼",
        "countryName": "常駐地區",
        "id": "身份証資料",
        "edit": "編輯",
        "complete": "完成",
        "placeholderFirstName": "請輸入您的姓氏",
        "placeholderName": "請輸入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "請輸入您的身份證/VISA卡/駕駛號碼",
        "isNull": "未填寫",
        "onlyNumber": "只能輸入數位或字母",
        "IDTip": "只能輸入數位或字母"
    },
    "member_modifyPassword": {
        "oldPsd": "舊密碼",
        "newPsd": "新密碼",
        "title": "修改密碼",
        "submit": "修改密碼",
        "setUp": "設定",
        "accountSetUp": "帳戶設定",
        "accountManage": "帳戶管理",
        "password": "密碼",
        "forgetPassword": "忘記密碼",
        "loginOut": "登出",
        "unsubscribe": "刪除帳戶",
        "unsubscribeAfter": "刪除帳戶後，您將放棄以下權利",
        "tip1": "通過活動贈送、代充值及充值碼兌換的餘額",
        "tip2": "未用完及贈送的流量套餐",
        "tip3": "刪除帳戶前，請認真閱讀",
        "ucloudlink": "《uCloudlink帳戶註銷須知》",
        "cancellation": "聯繫客服註銷帳戶",
        "oldPsdNull": "舊密碼不能為空",
        "newPsdNull": "新密碼不能為空",
        "modifyPasswordSuccess": "修改密碼成功"
    },
    "member_myDeviceOrder": {
        "title": "設備訂單",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消訂單"
        },
        "pending": "Pending Payment",
        "noData": "暫無設備訂單，請到商店看看~",
        "noList": "沒有數據~",
        "tryAgainLater": "請稍後再試"
    },
    "member_recharge": {
        "recharge": "充值",
        "rechargeAmount": "（選擇充值金額）",
        "present": "贈送",
        "currentBalance": "當前餘額",
        "payAmount": "充值金額",
        "unit": "￥",
        "pay": "確認支付",
        "alipay": "支付寶",
        "paypal": "PayPal",
        "operateMess": "操作提示",
        "giveMore": "贈送"
    },
    "member_equipmentManagement": {
        "noData": "沒有設備？",
        "knowMore": "了解更多",
        "bindDevice": "綁定設備",
        "placeholderIMEI": "請輸入設備IMEI號",
        "placeholderPwd": "請輸入設備初始密碼",
        "bindNow": "立即綁定",
        "myEquipment": "我的設備",
        "equipmentMunual": "設備手冊",
        "dataBound": "解除綁定",
        "bindSuccess": "綁定成功",
        "unBindSuccess": "解綁成功",
        "imeiNull": "設備IMEI不能為空",
        "pwdNull": "設備初始PWD不能為空"
    },
    "member_flowRecords": {
        "record": "流量歷史",
        "filter": "篩選",
        "trafficStatistics": "流量統計"
    },
    "member_balanceDetails": {
        "title": "購買記錄",
        "filter": "篩選",
        "total": "合計",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消訂單"
        }
    },
    "member_productBalanceDetails": {
        "remain": "剩餘可用流量",
        "validTime": "有效期",
        "coverage": "覆蓋範圍",
        "productIntro": "套餐描述",
        "buyTime": "購買時間",
        "unsubscribe": "退訂",
        "buyTimeTips": "以上時間基於中國北京時間（GMT+8）",
        "unsubscribeTips": "退訂成功，本次消費金額將退到[我的餘額]裡"
    },
    "users_login": {
        "loginPhone": "手機登錄",
        "loginEmail": "郵箱登錄",
        "register": "帳號註冊",
        "inputPhone": "請輸入手機號碼",
        "inputPassword": "請輸入密碼",
        "forgetPassword": "忘記密碼",
        "login": "登錄",
        "goToLogin": "去登陸",
        "inputEmail": "請輸入郵箱號",
        "smsCode": "短信驗證碼",
        "inputSMSCode": "請輸入短信驗證碼",
        "noReceiveCode": "沒收到驗證碼？",
        "resend": "重新發送",
        "nextStep": "下一步",
        "findByPhone": "通過手機找回",
        "findByEmail": "通過郵箱找回",
        "verifyByEmail": "請到郵箱驗證",
        "sendEmailTo": "我們已發送一封電子郵件到",
        "findYourPassword": "請點擊其中的連結，並按步驟操作來找回您的密碼",
        "noReceiveEmail": "收不到郵件？請檢查您的垃圾郵件和已刪除郵件目錄下是否有來自 glocalme@ucloudlink.com 的郵件。",
        "or": "或",
        "resetPassword": "重設密碼",
        "oldFormat": "至少6個字元",
        "passwordFormat": "6-20個字元(字母、數位或符號的組合)",
        "completeLogin": "完成並登錄",
        "resetPasswordSuc": "重設密碼成功",
        "backToGlocalMe": "請回到 GlocalMe Connect 登錄體驗",
        "activeReminder": "帳戶未啟動，請前往該郵箱，點擊啟動連結來完成您的帳戶註冊。",
        "known": "知道了"
    },
    "users_register": {
        "registerPhone": "手機註冊",
        "registerEmail": "郵箱註冊",
        "hasAccount": "已有帳號？",
        "agree": "我同意",
        "agreement": "使用者協定",
        "and": "和",
        "policy": "隱私政策",
        "logoutNotice": "永久刪除帳戶",
        "submit": "提交",
        "selectArea": "選擇常住地區",
        "countryOrRegion": "國家/地區",
        "change": "更換",
        "defaultRegion": "中國內地",
        "AE": "阿拉伯聯合酋長國",
        "search": "搜索熱門國家/地區",
        "reminder": "溫馨提示",
        "reminderTips": "選擇【",
        "reminderTips2": "】作為常駐地區，可享受該地區及周邊的專享優惠。選定後將不可更改。確定選擇嗎？",
        "confirm": "確定",
        "cancel": "取消",
        "setPassword": "設置密碼",
        "registerByEmail": "請點擊其中的連結來完成您的帳戶註冊。",
        "activeSuc": "啟動成功",
        "activeing": "正在激活",
        "activeAgain": "再次激活",
        "activeFail": "激活失敗",
        "verified": "我已驗證",
        "registerSuccess": "註冊成功"
    },
    "home": {
        "globalPackageCN": "全球暢享套餐",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "全球過百個合作伙伴",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "由於系統服務升級，您需要選擇常住國家或地區後方可繼續使用。",
        "reminderTips": "選擇【",
        "reminderTips2": "】作為常住地，可享受我們即將為該地及周邊推出的專享優惠；且帳戶餘額將",
        "reminderTips3": "按匯率【",
        "reminderTips4": "】",
        "reminderTips5": "轉換為【",
        "reminderTips6": "】顯示。選定後將不可更改。確定選擇嗎？",
        "gotoPC": "電腦版"
    },
    "privacyPolicy": {
        "changeDate": "私隱條款變更公告",
        "changeContain": "我們的私隱條款已於2018年7月更新。",
        "changeContain2": "我們非常重視您的私隱。因此我們制定了涵蓋如可收集、使用、披露、轉讓及儲存閣下信息的私隱政策。我們不會向任何第三方提供您的信息，除非已得到您的授權。若我們需要將信息用於未經授權之用途或目的，我們會事再次征求您的同意。",
        "changeContain3": "您可以閱讀完整的<a href=\"/users/agreement\" target=\"_blank\">《用戶協議》</a>和<a href=\"/users/privacy_policy\" target=\"_blank\">《私隱條款》</a>了解我們的承諾。",
        "noagree": "不同意",
        "agree": "同意"
    },
    "service": {
        "selectDevice": "選擇設備",
        "company": "企業方案",
        "faqs": "常見問題",
        "afterSale": "售後政策",
        "manual": "操作手冊",
        "safety": "安全措施",
        "coverage": "覆蓋區域"
    },
    "purchase": {
        "buy": "購買",
        "online": "網上商店",
        "offline": "線下門店",
        "distributor": "分銷商",
        "shopAddress": "店鋪地址",
        "shopTels": "聯繫電話"
    },
    "data_package": {
        "flowShop": "流量商店",
        "recommend": "為您推薦",
        "destination": "選擇目的地",
        "searchDestination": "搜索目的地",
        "historySearch": "歷史搜索",
        "clean": "清空",
        "more": "更多",
        "enjoyPackage": "暢享套餐",
        "commonPackage": "定量套餐",
        "include": "含",
        "areaPackage": "的跨區域套餐",
        "enjoyDay": "日暢享",
        "enjoyMonth": "月暢享",
        "unlimited": "無限",
        "houxiansu": "後限速",
        "currentMonth": "當月失效",
        "currentDay": "當日失效",
        "immediately": "立即生效",
        "morrow": "次日生效",
        "nextMonth": "次月生效",
        "iDay": "天",
        "iDays": "天",
        "iMonth": "個月",
        "iMonths": "個月",
        "cxtcIMonth": "月",
        "antarctica": "熱門",
        "asia": "亞洲",
        "european": "歐洲",
        "africa": "非洲",
        "northAmerica": "美洲",
        "southAmerica": "南美洲",
        "oceania": "大洋洲",
        "flow": "流量",
        "period": "有效期",
        "applicableArea": "適用區域",
        "useNotice": "使用須知",
        "cost": "需付金額",
        "order": "訂購",
        "confirmPay": "確認支付",
        "infiniteFlow": "無限流量",
        "unsubscribe": "不可退訂",
        "subscribe": "可退訂",
        "payFailed": "支付失敗",
        "paypalTips": "由於PayPal的認證機制，PayPal付款的資訊可能會出現延遲"
    },
    "pay_result": {
        "orderSuccess": "訂購成功",
        "chargeSuccess": "充值成功",
        "orderSucTips": "您購買的[ ",
        "orderSucTips2": " ]將在1分鐘內到賬，如長時間未到賬，請諮詢客服。",
        "orderSucTips3": "將在1分鐘內傳入您的帳戶，如長時間仍未入賬，請諮詢客服。",
        "packageName": "套餐名稱",
        "chargeAmount": "充值金額",
        "payAmount": "支付金額",
        "back": "返回首頁",
        "myFlow": "查看我的流量",
        "myBalance": "查看我的餘額",
        "tryLater": "請稍後再試",
        "succeed": "完成支付",
        "fail": "未能支付，請重新下單",
        "backToShop": "回到商城首頁",
        "successful": "交易成功",
        "rejected": "交易被拒絕，請聯繫您的銀行",
        "unsuccessful": "交易失敗，請重試",
        "referenceNumber": "訂單編號"
    },
    "my_order": {
        "month": "月",
        "day": "日"
    },
    "member_myFlow": {
        "myFlow": "我的流量",
        "remainHighSpeedTraffic": "剩餘高速",
        "validityPeriod": "有效期",
        "day": "天",
        "month": "月",
        "status": "狀態",
        "invalidPackage": "失效套餐",
        "usageRule": "使用規則",
        "close": "收起",
        "queryInvalidPackage": "查看失效套餐",
        "mccList": "適用區域",
        "usageMess": "使用須知",
        "payAmount": "支付金額",
        "payTime": "購買時間",
        "effectiveTime": "有效時間",
        "validTime": "生效時間",
        "invalidTime": "失效時間",
        "flow": "流量",
        "remainingFlow": "剩餘流量",
        "highSpeedTraffic": "高速流量",
        "remainHighSpeedTraffics": "剩餘高速流量",
        "unsubscribe": "退訂",
        "unsubscribed": "已退訂",
        "isCancelPackage": "是否退訂此套餐?",
        "actionTip1": "注：使用PayPal支付的訂單會收取",
        "actionTip2": " 手續費用",
        "reBack": "退款至【我的餘額】",
        "cancel": "取消",
        "cancelSuccess": "退訂成功",
        "reBackBy": "退款已退至【我的餘額】",
        "iKnow": "我知道了",
        "usageRule1": "暢享套餐優先使用",
        "usageRule2": "相同類型可用流量套餐預設按購買時間順序使用",
        "usageRule3": "若暢享套餐高速流量用完，將自動切換普通套餐使用",
        "packageUsageRule": "套餐使用規則",
        "dicObj": {
            "notActivated": "未啟動",
            "inUsing": "使用中",
            "useEnd": "已用完",
            "expire": "到期",
            "transfer": "已轉移",
            "unsubscribe": "退訂",
            "valid": "有效",
            "invalid": "無效",
            "currentMonth": "當月失效"
        },
        "to": " 至",
        "noData": "暫無流量套餐，立即前往流量商店",
        "noList": "沒有資料",
        "accumulatedThisHour": "本小時累積",
        "accumulatedThisDay": "本日累積",
        "accumulatedThisMonth": "本月累積",
        "accumulatedThisYear": "本年累積",
        "accumulatedFlow": "累積流量",
        "flowDetail": "流量詳情"
    },
    "select_area": {
        "destination": "選擇目的地",
        "selectCountry": "選擇熱門國家/地區"
    },
    "footer": {
        "belongs": "您的帳號屬於",
        "comeTo": "您已經來到",
        "site": "站",
        "changeTips": "您的帳號無法切換至其他站點",
        "changeTips2": "如需切換，請退出登錄",
        "switchWebsite": "您現在訪問其他站點與您賬號歸屬站點不一致，需要註銷登錄才能繼續訪問"
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside 是 uCloudlink 創新推出的全球數據流量服務，透過內置於手機的 GlocalMe Connect 流動應用程式，用戶即可享受由 CloudSIM 技術所帶來的全新數據連接體驗。",
            "title1": "簡單易用",
            "content1": "服務覆蓋全球，開機即可上網，商務人士可以簡單無憂地享用移動數據",
            "title2": "智能選網",
            "content2": "GlocalMe® Inside的智能選網功能可實時監測信號變化，自動連接當地最優網絡。",
            "title3": "本地資費",
            "content3": "與超過140個國家及地區建立運營商合作夥伴關係，為用戶帶來公平的本地數據資費。",
            "title4": "信息安全",
            "content4": "相對公共Wi-Fi，GlocalMe® Inside為用戶提供了高效的安全與私隱保護。",
            "title5": "GlocalMe® Inside世界手機一機在手，通行全球"
        },
        "u2": {
            "title": "輕薄之選",
            "title1_1": "一機在手 全球通行",
            "title1_2": "GlocalMe U2",
            "title2": "讓流動網絡更輕型",
            "title3_1": "香檳金",
            "title3_2": "寒鐵灰",
            "title4": "時尚輕薄 易於攜帶",
            "title5": "隨時隨地 享服4G網絡",
            "title6": "基本規格",
            "title7_1": "全球覆蓋 網絡隨身",
            "title7_2": "GlocalMe「零漫游」全球流動網絡服務覆蓋5大洲100多個國家及地區",
            "title7_3": "全球網絡隨時隨地，任意連網。"
        },
        "g3": {
            "title1_1": "長效續航「零漫遊」隨身Wi-Fi",
            "title1_2": "旗艦級GlocalMe G3",
            "title2_1": "出國必備的旅遊伴侶",
            "title3_1": "黑 x 寒鐵灰邊框",
            "title3_2": "白 x 香檳金邊框",
            "title4_1": "覆蓋更廣 網絡連接更自由",
            "title4_2": "服務環跨歐、美、亞、非及大洋等5大洲，超過100多個國家及地區",
            "title4_3": "無需插入SIM卡，隨時隨地連接網絡",
            "title4_4": "詳情參閱「覆蓋區域」",
            "title5_1": "電力充沛 為您充電",
            "title5_2": "電量亦可輸出，為手機等小型電子設備充電",
            "title5_3": "5350mAh鋰離子電池，可持續使用長達15小時",
            "title5_4": "",
            "title6_1": "「零漫遊」暢享全球最佳本地網絡",
            "title6_2": "以自主研發的雲SIM技術，實時偵測和轉換最優網絡",
            "title7_1": "共享快樂",
            "title7_2": "5人分享，5機連線；設備不限於手機、手提或平板電腦等智能設備",
            "title8_1": "專屬APP 二站式全面掌握",
            "title8_2": "隨時隨地網上充值、購買流量，並查核用量記錄及管理設備，支付方式：包括信用卡、Paypal、銀聯、微信支付、支付寶等",
            "title8_3": "掃碼下載，GlocalMe手機應用程式",
            "title9_1": "資費彈性 無需合約",
            "title9_2": "流量套餐",
            "title9_3": "多元化選擇，由地區、有效期至流量限額，滿足您的各種需求",
            "title9_4": "Pay-As-You-Go:",
            "title9_5": "計費USD0.05/MB，12美元封頂，限速不限流量，詳見流量商店",
            "title9_6": "專屬地點 安全可靠",
            "title9_7": "採用Wi-Fi加密機制，加強網絡保安",
            "title9_8": "防止掉入免費Wi-Fi的黑洞"
        },
        "p3": {
            "title1_1": "多彩生活，一定有一個屬於你的顏色",
            "title1_2": "創新與和諧並重的設計，源自對產品形狀，材質與顏色的同步研發，各元素之間彼此呼應，一同創造出類拔萃，意義非凡的智慧手機",
            "title3": "通過CloudSIM技術實現，不再需要漫遊和SIM卡。",
            "title4": "你和他們之間的距離只差\"我\"",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "創新的全球數據流量服務，通過內置的GlocalMe® Connect APP，用戶即可享受由CloudSIM技術帶來的前所未有的資料連接體驗",
            "title6_1": "等等，還有更多！",
            "title6_2": "我們服務包括"
        },
        "simbox": {
            "title": "SIMBOX",
            "title1": "手機秒變多卡多待",
            "title2": "15大優勢滿足多卡管理需求",
            "title3": "讓手機秒變多卡多待",
            "title4": "國際通話 零漫遊費",
            "title5": "真4G，全網通",
            "title6_1": "7x24小時線上",
            "title6_2": "電話/短信不漏接",
            "title7": "方正精緻，簡約時尚"
        },
        "glocalme_wifi": {
            "title": "為什麼選擇GlocalMe Wi-Fi"
        },
        "glocalme_phone": {
            "title": "為什麼選擇GlocalMe世界機"
        }
    },
    "about": {
        "contact": "聯繫我們",
        "news": "新聞動態",
        "glocalme": "關於我們",
        "partnership": "尋求合作",
        "partnerships": "合作夥伴",
        "note": "為了讓我們更了解您的合作意向，請填以下表格，我們會盡快與閣下聯繫！",
        "username": "姓名",
        "email": "電郵",
        "company": "公司名稱",
        "position": "職位",
        "phone": "電話",
        "demand": "詳情",
        "success": "成功",
        "deviceType": "產品類型",
        "quantity": "產品數量",
        "address": "地址",
        "heard": "從哪個途徑認識我們？",
        "agreement": "同意<a href=\"/users/privacy_policy\">《隱私政策》</a>和<a href=\"/users/agreement\">《用戶協議》</a>，uCloudlink 將會透過電郵或電話號碼與您聯繫"
    },
    "validate": {
        "isEmail": "電郵格式",
        "isMobilePhone": "手機號碼",
        "isChinaName": "中文姓名",
        "required": "必填",
        "format": "格式不正確",
        "min": "最少需要輸入",
        "max": "最多可以輸入",
        "char": "個字元",
        "equal": "輸入不一致",
        "invalid": "您的輸入含有非法字元，如 <>, >< 等",
        "digits": "產品數量 5-100"
    },
    "newCreate": {
        "onlyForAE": "此設備僅限常駐地為阿聯酋的用戶使用",
        "purchaseTips": "此頁面只提供英文內容"
    }
};

/***/ }),

/***/ "V1NV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by zhengyi.fu on 2020/6/8.
 */
var date = function date(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    var _date = new Date(timestamp);
    var y = _date.getFullYear();
    var m = _date.getMonth() + 1;
    var d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep + doubleNum(d);
};

var doubleNum = function doubleNum(n) {
    if (n.length > 2 || n > 100) {
        return n;
    }
    n = parseInt(n);
    return n >= 10 ? "" + n : "0" + n;
};

var time = function time(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";

    var _date = new Date(timestamp);
    var h = _date.getHours();
    var m = _date.getMinutes();
    var s = _date.getSeconds();
    return doubleNum(h) + sep + doubleNum(m) + sep + doubleNum(s);
};

var dateTime = function dateTime(timestamp) {
    var dateSep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
    var timeSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ":";

    return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
};

/**
 * 返回1970年至今的毫秒数
 * @param secs
 * @returns {Date}
 */
var dateWithTimeIntervalSince1970 = function dateWithTimeIntervalSince1970(secs) {
    var timestamp = secs;
    var newDate = new Date();
    newDate.setTime(timestamp);
    return newDate;
};

var toYuan = function toYuan(money) {
    //分->显示元
    if (money === "") return "";
    var a = parseInt(money) / 100;
    var str = a + '';
    var arr = str.split('.');
    arr[1] = (arr[1] || '') + '00';
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].replace(/[^0-9\-]/);
    }
    arr[1] = arr[1].substr(0, 2);
    return [arr[0], arr[1]].join('.');
};

var keepTwodecimalFull = function keepTwodecimalFull(num) {
    //保留两位小数
    var result = parseFloat(num);
    if (isNaN(result)) {
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.'); //小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
};

module.exports = {
    date: date,
    time: time,
    dateTime: dateTime,
    doubleNum: doubleNum,
    dateWithTimeIntervalSince1970: dateWithTimeIntervalSince1970,
    keepTwodecimalFull: keepTwodecimalFull,
    toYuan: toYuan
};

/***/ }),

/***/ "Vfcl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// 新闻中心
{
	path: 'about/news',
	component: (0, _import3.default)('about/news')
},
// 关于glocalme
{
	path: 'about/glocalme_old',
	component: (0, _import3.default)('about/glocalme')
},
// 联系glocalme
{
	path: 'about/contact_old',
	component: (0, _import3.default)('about/contact')
},
// 寻找合作
{
	path: 'about/partnership',
	component: (0, _import3.default)('about/partnership')
},
// 新闻详情
{
	path: 'about/newsDetail/:id',
	component: (0, _import3.default)('about/newsDetail')
}];

/***/ }),

/***/ "WBBB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (appConfig) {
    var Obj = {};
    // 获取配置的mvnoCode等参数列表
    Obj.getMvno = function (giso) {
        var url = _api2.default.interfaces.getMvno;
        if (giso) url += "?giso=" + giso;
        return _request2.default.post(url, {}, { notShowLoading: true });
    };
    // 获取mvnoCode等参数列表的具体参数值
    Obj.getMvnoParam = function (key, obj) {
        for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
                if (key === k) {
                    return obj[k];
                }
            }
        }
        return '';
    };
    // CMS资源相对路径转成绝对路径
    Obj.getCMSImgPath = function (a) {
        var myUrl = appConfig.myUrl;
        var reg = new RegExp(/http[s]?:\/\//);
        if (reg.test(a)) {
            // 绝对路径直接返回
            return a;
        }
        return a ? myUrl + a.replace(/^[.\/]*/, '') : '';
    };
    // 获取用户信息
    Obj.getUserInfo = function (obj) {
        return _request2.default.post(_api2.default.member.userInfo, obj);
    };
    // 价格转换
    Obj.YuanToFen = function (price) {
        return price ? price * 100 : '0';
    };
    /**
     * @return {string}
     */
    Obj.FenToYuan = function (price) {
        if (price) {
            var temp_price = parseInt(price) / 100 + '';
            var arr = temp_price.split('.');
            arr[1] = (arr[1] || '') + '00';
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].replace(/[^0-9\-]/, '');
            }
            arr[1] = arr[1].substr(0, 2);
            return arr.join('.');
        } else {
            return '0.00';
        }
    };
    // 流量转换
    /**
     * @return {string}
     */
    Obj.ByteToMB = function (byte) {
        return byte ? (byte / (1024 * 1024)).toFixed(2) : '0';
    };
    /**
     * @return {string}
     */
    Obj.MBToGB = function (mb) {
        if (0 <= mb && mb < 1024) {
            return mb + 'M';
        } else if (1024 <= mb && mb <= 999999) {
            return Math.floor(mb / 1024) + 'G';
        } else {
            return 'GB';
        }
    };
    Obj.toFixed2 = function (mb) {
        //mb保留两位小数
        if (mb && mb !== 0) {
            return mb.toFixed(2);
        } else {
            return 0;
        }
    };
    //转换时间long格式到yyyy-mm-dd hh-MM-ss
    Obj.getFormatTime = function (d) {
        if (!d) {
            return;
        }
        var date = new Date(d);
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        M = M < 10 ? "0" + M : M;
        var D = date.getDate() + ' ' < 10 ? "0" + (date.getDate() + ' ') : date.getDate() + ' ';
        var h = date.getHours();
        h = (h < 10 ? "0" + h : h) + ':';
        var m = date.getMinutes();
        m = (m < 10 ? "0" + m : m) + ':';
        var s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return Y + M + D + h + m + s;
    };
    //获取当前时间转换格式到yyyyMMddhhmmssSSS
    Obj.getMillisecondsFormat = function () {
        var date = new Date();
        var y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        var S = date.getMilliseconds();
        if (S < 10) {
            S = "00" + S;
        } else if (S < 100) {
            S = "0" + S;
        }

        return '' + y + M + d + h + m + s + S;
    };
    // cookie language语言值修正
    Obj.getLanguage = function (lang) {
        if (lang === "zh-CN" || lang === "zh-TW" || lang === "zh-HK" || lang === "en-US") {
            return lang;
        } else {
            return "zh-CN";
        }
    };
    //支付时的3D验证开关配置化
    Obj.threeDSecureBtn = function () {
        var btnFlag = appConfig.threeDSecureBtn;
        return btnFlag;
    };
    // rent device iframe url
    Obj.apiDomain = function () {
        return appConfig.api_domain || '';
    };

    return Obj;
};

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _api = __webpack_require__("h2kg");

var _api2 = _interopRequireDefault(_api);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "Ww3I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    path: 'mall',
    name: 'mall',
    component: (0, _import3.default)('us_mall/layout'),
    alias: [''],
    redirect: {
        name: 'newHome'
    },
    children: [
    // 首页
    {
        path: 'index',
        name: "newHome",
        alias: [''],
        component: (0, _import3.default)('us_mall/home/index')
    }, {
        path: 'product_detail/:device_type',
        name: "productDetail",
        alias: [''],
        component: (0, _import3.default)('us_mall/home/product_detail')
    },
    //  下单成功
    {
        path: 'orderSuccess',
        component: (0, _import3.default)('us_mall/order/orderSuccess')
    },
    // 购买设备
    {
        path: 'product_choose',
        component: (0, _import3.default)('us_mall/mall/product_choose')
    },
    // 购物车
    {
        path: 'cart',
        component: (0, _import3.default)('us_mall/mall/cart')
    },
    // 下单
    {
        path: 'orderSettlement',
        component: (0, _import3.default)('us_mall/order/order_settlement')
    },
    // 申请退货
    {
        path: 'return_apply',
        component: (0, _import3.default)('us_mall/order/return_apply')
    },
    // 退货成功
    {
        path: 'return_suc',
        component: (0, _import3.default)('us_mall/order/return_suc')
    },
    // 取消订单
    {
        path: 'order_cancel',
        component: (0, _import3.default)('us_mall/order/order_cancel')
    },
    // 订单已取消
    {
        path: 'order_canceled',
        component: (0, _import3.default)('us_mall/order/order_canceled')
    },
    // 支付页
    {
        path: 'paymentPage',
        component: (0, _import3.default)('us_mall/order/paymentPage')
    },
    // 服务
    {
        path: 'service/index',
        component: (0, _import3.default)('us_mall/service/index')
    },
    // 隐私政策
    {
        path: 'service/policy',
        component: (0, _import3.default)('us_mall/service/policy')
    },
    // 关于
    {
        path: 'about/us',
        component: (0, _import3.default)('us_mall/service/about')
    },
    // cooperation
    {
        path: 'about/cooperation',
        component: (0, _import3.default)('us_mall/service/cooperation')
    },
    // 关于
    {
        path: 'about/contact',
        component: (0, _import3.default)('us_mall/service/contact_us')
    },
    // how
    {
        path: 'how',
        component: (0, _import3.default)('us_mall/how/how_index')
    },
    // 购买记录---设备订单详情
    {
        path: 'member/myDeviceOrderDetail',
        name: 'myDeviceOrderDetail',
        component: (0, _import3.default)('member/myDeviceOrderDetail'),
        meta: {
            requiresAuth: true
        }
    },
    // 再次支付
    {
        path: 'repayments',
        component: (0, _import3.default)('us_mall/order/repayments')
    }]
}]; /**
     * Created by xing.lin on 2020/9/3.
     */

/***/ }),

/***/ "XmAf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xwp3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "us_mall": {
        "feature_one": "Free, fast shipping",
        "feature_two": "Free, easy return",
        "feature_three": "6-Month Warranty",
        "quantity": "数量：",
        "tax_tips": "Tax caculation",
        "buy": "立即购买",
        "check_out": "结算",
        "select_one": "请选择一条数据",
        "free_shipping": "免运费"
    },
    "product": {
        "choose_device_title": "请选择你需要购买的设备类型",
        "choose_package_title": "请选择配套的流量套餐",
        "add_to_cart": "加入购物车",
        "suc": "成功",
        "err": "失败"
    },
    "cart": {
        "pc_cart_title": "我的购物车",
        "cart_title": "购物车",
        "remove": "移除",
        "total": "合计:",
        "noCart_title": "您的购物车已空!",
        "noCart_subTitle": "登录查看是否有已选中的商品，或继续购物",
        "sign": "重新登录",
        "shopping": "继续购物",
        "select_product": "请勾选需要结算的商品"
    },
    "settlement": {
        "title": "SECURE CHECKOUT",
        "delivery": "Delivery",
        "pick_up": "Pick up",
        "form_title": "输入您的收件信息",
        "province": "省份",
        "city": "城市",
        "district": "区域",
        "required": "此为必填项",
        "firstName": "First name",
        "lastName": "Last name",
        "address1": "Address line 1",
        "address2": "Address line 2",
        "state": "State/Province/Region",
        "zipCode": "Zip code",
        "contactInfo": "Contact information",
        "customerName": "收件人",
        "phone": "手机号码",
        "detailed_Address": "详细地址",
        "payMethod_title": "支付方式",
        "payMth_weChat": "微信支付",
        "contact_checked": "Subscribe to our news letter to receive exclusive deals",
        "ship": "Shipping method",
        "payment": "Payment method",
        "pickup_spot": "Available pickup spot",
        "name": "Name",
        "order_summary": "订单汇总",
        "apply": "Apply",
        "subtotal": "商品总价",
        "shipping": "运费：",
        "tax": "Tax",
        "total": "合计:",
        "privacy": "By placing this order, you agree to our<a href=\"/member/agreement\">Terms and Conditions</a> and <a href=\"/users/privacy_policy\">Privacy Policy</a>.",
        "order": "提交订单",
        "paymentCompleted": "已完成付款",
        "wxScanTips": "请使用微信扫一扫付款",
        "payForWeChat": "微信支付",
        "exchange": "兑换",
        "remove": "移除",
        "exchangeSuc": "兑换码已成功兑换",
        "exchangeFail": "请输入有效的兑换码",
        "invalidCoupon": "无效的优惠券",
        "notExistCoupon": "优惠券码不存在或已失效",
        "ExpiredCoupon": "优惠券使用次数超出限制或已过期",
        "InvalidCode": "无效码"
    },
    "cooperation": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "position": "Position",
        "companyName": "Company Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "productInterst": "Main Product of Interest",
        "estimatedQuantity": "Estimated Quantity of Product"
    }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

var _users = __webpack_require__("qWdx");

var _users2 = _interopRequireDefault(_users);

var _about = __webpack_require__("Vfcl");

var _about2 = _interopRequireDefault(_about);

var _member = __webpack_require__("ECvG");

var _member2 = _interopRequireDefault(_member);

var _service = __webpack_require__("1bcz");

var _service2 = _interopRequireDefault(_service);

var _register = __webpack_require__("qcJA");

var _register2 = _interopRequireDefault(_register);

var _glocalme = __webpack_require__("LwXw");

var _glocalme2 = _interopRequireDefault(_glocalme);

var _cloudsim = __webpack_require__("2QS9");

var _cloudsim2 = _interopRequireDefault(_cloudsim);

var _worldphone = __webpack_require__("y7FU");

var _worldphone2 = _interopRequireDefault(_worldphone);

var _simbox = __webpack_require__("mDSd");

var _simbox2 = _interopRequireDefault(_simbox);

var _data_package = __webpack_require__("uOPr");

var _data_package2 = _interopRequireDefault(_data_package);

var _purchase = __webpack_require__("hedY");

var _purchase2 = _interopRequireDefault(_purchase);

var _us_mall = __webpack_require__("Ww3I");

var _us_mall2 = _interopRequireDefault(_us_mall);

var _PagesView = __webpack_require__("iMmR");

var _PagesView2 = _interopRequireDefault(_PagesView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{
    // path: '/:_locale([A-Za-z]{2})?/:_lang([A-Za-z]{2})?',
    path: '/',
    component: _PagesView2.default,
    alias: [''],
    children: [
    // 首页
    {
        path: 'home',
        name: 'home',
        component: (0, _import3.default)('home')
    },
    // 流量商城
    {
        path: 'data_package',
        name: 'data_package',
        component: (0, _import3.default)('data_package')
    },
    // 老用户切换选择注册国家/地区
    {
        path: 'old_select',
        name: 'old_select',
        component: (0, _import3.default)('old_select')
    }].concat((0, _toConsumableArray3.default)(_cloudsim2.default), (0, _toConsumableArray3.default)(_worldphone2.default), (0, _toConsumableArray3.default)(_simbox2.default), (0, _toConsumableArray3.default)(_users2.default), (0, _toConsumableArray3.default)(_about2.default), (0, _toConsumableArray3.default)(_service2.default), (0, _toConsumableArray3.default)(_register2.default), (0, _toConsumableArray3.default)(_glocalme2.default), (0, _toConsumableArray3.default)(_member2.default), (0, _toConsumableArray3.default)(_data_package2.default), (0, _toConsumableArray3.default)(_purchase2.default), (0, _toConsumableArray3.default)(_us_mall2.default), [
    // 引导关注百弈通微信公众号页面
    {
        path: 'guide_byt',
        component: (0, _import3.default)('guide_byt')
    }])
},
// 404 页面
{
    path: '/:_locale([A-Za-z]{2})?/:_lang([A-Za-z]{2})?/404',
    name: '404',
    component: (0, _import3.default)('404')
}, {
    path: '*',
    redirect: '404'
}];
exports.default = {
    mode: 'history',
    routes: routes
    /*export default new Router({
        mode: 'history',
        routes
    });*/

};

/***/ }),

/***/ "a16M":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/usmall.js": "FeGY",
	"./tw/usmall.js": "3v4D",
	"./zh/usmall.js": "Xwp3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a16M";

/***/ }),

/***/ "aN9Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b5pa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c4qo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/libs/statusBus.js
var statusBus = __webpack_require__("A62N");
var statusBus_default = /*#__PURE__*/__webpack_require__.n(statusBus);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/com-footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var com_footer = ({
  components: {},
  data: function data() {
    return {
      statusBus: statusBus_default.a,
      screenWidth: document.body.clientWidth,
      showQRcode: false,
      navData: {},
      versionInfo: '',
      footerShow: false
    };
  },

  methods: {
    enter: function enter() {
      this.showQRcode = true;
    },
    leave: function leave() {
      this.showQRcode = false;
    },
    setCommonData: function setCommonData() {
      this.navData = staticData.nav;
      this.versionInfo = staticData.website.site_info.site_copyright || "";
    }
  },
  created: function created() {
    var _this = this;

    this.statusBus.isPC = this.screenWidth > 1024;
    window.addEventListener("resize", function () {
      _this.statusBus.isPC = document.documentElement.clientWidth > 1024;
    });
  },
  mounted: function mounted() {
    this.setCommonData();
  },

  watch: {
    $route: {
      handler: function handler(to, from) {
        if (this.$route.path == '/' || this.$route.path == '/about/us') {
          this.footerShow = true;
        } else {
          this.footerShow = false;
        }
      },

      deep: true,
      immediate: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/com-footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_com_footer = ({
  components: {},
  data: function data() {
    return {
      statusBus: statusBus_default.a,
      screenWidth: document.body.clientWidth,
      showQRcode: false,
      navData: {},
      versionInfo: '',
      footerShow: false
    };
  },

  methods: {
    enter: function enter() {
      this.showQRcode = true;
    },
    leave: function leave() {
      this.showQRcode = false;
    },
    setCommonData: function setCommonData() {
      this.navData = staticData.nav;
      this.versionInfo = staticData.website.site_info.site_copyright || "";
    }
  },
  created: function created() {
    var _this = this;

    this.statusBus.isPC = this.screenWidth > 1024;
    window.addEventListener("resize", function () {
      _this.statusBus.isPC = document.documentElement.clientWidth > 1024;
    });
  },
  mounted: function mounted() {
    this.setCommonData();
  },

  watch: {
    $route: {
      handler: function handler(to, from) {
        if (this.$route.path == '/' || this.$route.path == '/about/us') {
          this.footerShow = true;
        } else {
          this.footerShow = false;
        }
      },

      deep: true,
      immediate: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db03c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"glocalme-footer"},[_vm._t("default"),_vm._v(" "),(!_vm.statusBus.isPC && _vm.footerShow)?_c('div',{staticClass:"mobile_footer"},[_c('div',{staticClass:"footer_inner"},[_c('div',{staticClass:"footer_bar_left"},[_vm._l((_vm.navData.foot),function(item,index){return _c('p',{key:index,staticClass:"footer_nav_item",style:(index === (_vm.navData['foot'].length-1) ? 'borderRight: none;':'borderRight: 1px solid #E3E3E3;'),attrs:{"target":"_blank"}},[_c('a',{attrs:{"href":item.link},domProps:{"textContent":_vm._s(item.name)}})])}),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('p',{staticClass:"copy_right"},[_vm._v(_vm._s(_vm.versionInfo))])],2),_vm._v(" "),_vm._m(0)])]):_vm._e(),_vm._v(" "),(_vm.statusBus.isPC)?_c('div',{staticClass:"pc_footer"},[_c('div',{staticClass:"footer_inner"},[_c('div',{staticClass:"footer_bar_left"},[_vm._v(_vm._s(_vm.versionInfo))]),_vm._v(" "),_c('div',{staticClass:"footer_bar_center"},_vm._l((_vm.navData.foot),function(item,index){return _c('p',{key:index,staticClass:"footer_nav_item"},[_c('a',{style:(index === (_vm.navData['foot'].length-1) ? 'borderRight: none;':'borderRight: 1px solid #E3E3E3;'),attrs:{"href":item.link,"target":"_blank"},domProps:{"textContent":_vm._s(item.name)}})])})),_vm._v(" "),_c('div',{staticClass:"footer_bar_right",on:{"mouseenter":_vm.enter,"mouseleave":_vm.leave}},[_vm._v("微信公众号")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showQRcode),expression:"showQRcode"}],staticClass:"QRcode"})])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_bar_right"},[_c('img',{attrs:{"src":"/static/img/images/m-QRcode.png"}}),_vm._v(" "),_c('p',[_vm._v("微信公众号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_com_footer = (esExports);
// CONCATENATED MODULE: ./src/components/com-footer.vue
function injectStyle (ssrContext) {
  __webpack_require__("b5pa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_com_footer,
  selectortype_template_index_0_src_components_com_footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_com_footer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEaa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__("TXmL");

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _zh = __webpack_require__("N4h9");

var _zh2 = _interopRequireDefault(_zh);

var _tw = __webpack_require__("RFS8");

var _tw2 = _interopRequireDefault(_tw);

var _en = __webpack_require__("p9le");

var _en2 = _interopRequireDefault(_en);

var _import2 = __webpack_require__("QaSf");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

var messages = {
    //default
    en: (0, _extends3.default)({}, _en2.default, _import3.default["en"]),
    zh: (0, _extends3.default)({}, _zh2.default, _import3.default["zh"]),
    tw: (0, _extends3.default)({}, _tw2.default, _import3.default["tw"])
};
var i18n = new _vueI18n2.default({
    //default language
    locale: 'en',
    messages: messages
});

exports.default = i18n;

/***/ }),

/***/ "erWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h2kg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by xuetao.liu on 2018/10/9.
 * @Description global api
 */
exports.default = {
    account: {
        balance: "/bss/app/user/QueryBalanceInfo", // 获取账户余额
        chargeList: "/bss/app/noauth/QueryOfferList", //销售品查询
        queryFlowStatistical: "/bss/dsds/user/QueryFlowDetailDay", //流量统计查询
        queryOrderList: "/bss/app/order/QueryOrderList", //查询订单列表
        queryDictionary: "/bss/app/noauth/dictionary/QueryDictionaryValueListInfo", //字典查询
        queryUserOffer: "/bss/app/orderRelation/QueryUserOfferList", //我的流量列表---用户套餐列表
        // cancelPackage:"/bss/app/orderRelation/UnsubscribePkg",          //退订套餐
        cancelPackage: "/bss/app/order/CancelOrder", // 退订套餐
        codeCharge: "/bss/app/topup/TopUpByVoucher" //充值码充值
    },
    register: {
        SMS: "/bss/app/noauth/GetVerificationCodeBySMS", // 获取短信验证码接口
        registerUser: "/bss/app/noauth/RegisterUser", // 注册用户接口
        resetPwd_SMS: "/bss/app/noauth/ResetPasswordBySMS", // 短信重置密码接口
        MAIL: "/bss/app/noauth/SendResetPasswordMail", // 发送重置密码邮件接口
        resetPwd_MAIL: "/bss/app/noauth/ResetPasswordByMail", // 邮件重置密码接口
        active_MAIL: "/bss/app/noauth/SendActivationMail", // 发送激活邮件接口
        activeUser: "/bss/app/noauth/ActiveUser", // 激活账号接口
        checkUser: "/bss/app/noauth/CheckUserCode", // 校验用户名称合法性
        checkSMS: "/bss/dsds/noauth/VerifyVerificationCodeFromDSDS" // 校验短信验证码接口
    },
    interfaces: {
        getCountryInfo: "/api/interfaces/getCountryInfo", // 获取国家/地区列表接口
        getServiceLists: "/api/interfaces/qalist", // 获取列表接口
        getContent: "/api/interfaces/getcontent", // 获取内容接口
        getPurchase: "/api/interfaces/getpurchasing", // 获取购买数据接口
        about: "/api/frame/web/cms/about?op=getcontent", //关于
        newslist: "/api/interfaces/newslist",
        newsdetail: "/api/interfaces/newsdetail", //新闻详情
        getMvno: "/api/interfaces/getMvnoCode", // 获取mvnoCode接口
        getOpenID: "/api/interfaces/getWeChatOpenid", // 获取微信openID
        getIp: "/api/interfaces/getIp", // 获取IP
        getConfig: "/api/interfaces/get_agreement",
        getCurrencyConfig: "/api/interfaces/getCurrencyConfig",
        filterPackage: "/api/interfaces/get_packages_filter", // 过滤套餐
        cybersource: "/api/interfaces/cybersource", // 接收cybersource平台post过来的data
        partnership: "/api/interfaces/parnership", // 合作伙伴提交合作意向信息
        getuDeskSign: "/api/interfaces/getUDeskSignature", // 获取生成的uDesk客服鉴权字符串
        pushInformation: "/api/interfaces/pushInformation", // 用户协议和隐私条款增加版本号
        getRecommendDevice: "/api/interfaces/recommendedProducts", // 获取首页推荐设备
        purchasePoint: "/api/interfaces/purchasePoint", // 获取销售点数据接口（新）
        getPoster: "/api/interfaces/productPoster", // 获取设备海报接口（新）
        getSEO: "/api/interfaces/seoCanonicalization", // 获取seo规范接口（新）
        getCooper: "/api/interfaces/toSeekCooperation", // 获取寻求合作列表接口（新）
        getDevice: "/api/interfaces/sku", // 获取设备信息
        getStateTax: "/api/interfaces/stateTax", // 获取州税
        getDeliveryCompany: "/api/interfaces/deliveryCompany", // 获取快递公司
        getWarehouses: "/api/interfaces/warehouses", // 获取仓库
        viaCMS: "/api/interfaces/viaCMS", // cms中转oms
        placeOrder: "/api/interfaces/placeOrder", // 创建订单接口
        preCompute: "/api/interfaces/precomputation", // 价格预计算接口
        orderEnquiry: "/api/interfaces/orderEnquiry", // 再次支付部分参数需要查询的接口
        interLogistics: "/api/interfaces/internationalLogistics" // 国家物流的接口
    },
    member: {
        login: "/api/member/ajax_login", // 登录接口
        userInfo: "/bss/app/user/QueryUserInfo", // 获取用户信息
        saleOrderList: '/api/frame/web/order/saleOrderList', // 查询用户售卖订单列表
        saleOrderDetail: '/api/frame/web/order/saleOrderDetail', // 查询用户售卖订单详情
        orderCancel: '/api/frame/web/order/cancel' //取消订单接口
    },
    home: {
        background: "/api/frame/web/cms/index", //首页background
        module: "/api/interfaces/indexmodule", //content
        links: "/api/interfaces/indexlinks", //友情链接
        navList: "/api/interfaces/navlist", //导航
        footerInfo: "/api/interfaces/footer_info", //底部
        versionInfo: "/api/interfaces/getVersionInfo", //底部
        enterpriseList: "/bss/app/noauth/queryEnterpriseConfigList", // 获取分站配置
        rate: "/bss/app/noauth/QueryCurrencyRateInfo" // 获取费率
    },
    data_package: {
        recommend: "/bss/dsds/noauth/QueryRecommendOfferList", // 获取推荐销售品接口
        rate: "/bss/app/noauth/QueryRateList", // 获取费率接口
        getPackage: "/bss/app/noauth/QueryOfferList", // 获取套餐销售品接口
        getPayConfig: "/api/interfaces/getpaymentconfig", // 获取配置支付方式
        getOrderList: "/bss/app/order/QueryOrderList", // 订单查询接口
        createOrder: "/bss/app/order/CreateOrder", // 创建订单
        balance: "/bss/app/order/DoPayByBalance", // 余额支付
        alipay: "/alipay/GetAlipayCredential", // 支付宝
        paypal: "/paypal/GetPaypalCredential", // paypal
        getPaypalCurr: "/paypal/GetPaypalCurrencyType", // 获取paypal支付货币
        weixin: "/weixin/GetWeixinCredential", // 微信
        union: "/union/GetUnionCredential", // 银联
        cybersource: "/payment/gateway", // 信用卡
        queryEnterpriseConfigList: "/bss/app/noauth/queryEnterpriseConfigList"
    },
    modify_information: {
        queryUserInfo: "/bss/app/user/QueryUserInfo", //进入界面，获取帐号的相关信息
        updateUserInfo: "/bss/app/user/UpdateUserInfo" //编辑提交-身份信息
    },
    equipmentManagement: {
        queryDeviceBindingInfo: "/bss/app/terminal/QueryDeviceBindingInfo", //查询帐号绑定信息
        handleDeviceBinding: "/bss/app/terminal/HandleDeviceBinding" //提交---绑定或解除绑定IMEI
    },
    modifyPassword: {
        userLogout: "/bss/app/user/UserLogout", //退出登录
        updatePassword: "/bss/app/user/UpdatePassword" //修改密码
    },
    common: {
        sendEmail: "/bss/ucp/ucpsend/email/sendEmail" // 发送邮件
    },
    mps: {
        queryOrgCode: "/webmps/user/device/queryOrgCode" // 检测IMEI是否归属阿联酋
    },
    oms: {
        queryCouponCode: "/api/thirdInfo/thirdPartyQueryCoupon", // 查询oms优惠码接口
        queryOrderSale: "/api/sale/queryOrderSale" // 查询oms订单接口
    },
    us_mall: {
        queryProductList: "/api/frame/web/sku/deviceList", // 查询产品列表
        queryDeviceContent: "/api/frame/web/sku/graphicContent", // 查询设备详情的图文信息
        addCart: "/api/frame/web/cart/add", // 添加到购物车
        queryCart: "/api/frame/web/cart/userCartList", // 查询用户的购物车数据
        removeCart: "/api/frame/web/cart/remove", // remove单条购物车数据
        syncData: "/api/frame/web/cart/sync", // 同步购物车数据
        cancelOrReturn: "/api/frame/web/order/cancel", //订单取消、退款、退货接口
        getCMS: "/api/frame/web/cms/index",
        getCoop: "/api/frame/web/cms/about?op=toSeekCooperation",
        getSupport: "/api/frame/web/cms/support",
        placeSaleOrder: "/api/frame/web/order/placeSaleOrder", //售卖产品下单接口
        getWXAuthUrl: "/api/frame/web/weixin/authCodeUrl", //获取微信授权url
        bindOpenid: "/api/frame/web/weixin/bindOpenid", //微信openid与用户信息绑定
        saleOrderDetail: "/api/frame/web/order/saleOrderDetail", //订单详情
        upDateCart: "/api/frame/web/cart/update", //更新购物城商品数量
        productPoster: "/api/frame/web/cms/cloudsim", //产品详情海报
        verify: "/api/frame/web/coupon/verify", //优惠券使用验证
        calculateOrderAmount: "/api/frame/web/order/calculateOrderAmount" //计算下单金额
    }
};

/***/ }),

/***/ "hedY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// 购买设备
{
    path: 'purchase/device_purchase',
    component: (0, _import3.default)('glocalme/device_purchase'),
    children: [{
        path: '*',
        component: (0, _import3.default)('glocalme/device_purchase')
    }]
}, {
    path: 'purchase/device_order_confirmation',
    component: (0, _import3.default)('glocalme/device_order_confirmation'),
    children: [{
        path: '*',
        component: (0, _import3.default)('glocalme/device_order_confirmation')
    }]
}, {
    path: 'purchase/device_order_payment',
    component: (0, _import3.default)('glocalme/device_order_payment'),
    children: [{
        path: '*',
        component: (0, _import3.default)('glocalme/device_order_payment')
    }]
},
// 支付结果页面---设备订单详情
{
    path: 'purchase/device_order_success',
    name: 'orderResult',
    component: (0, _import3.default)('glocalme/orderResult'),
    children: [{
        path: '*',
        component: (0, _import3.default)('glocalme/orderResult')
    }]
}];

/***/ }),

/***/ "iMmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/com-footer.vue + 3 modules
var com_footer = __webpack_require__("c4qo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/PagesView.vue
//
//
//
//
//
//
//


/* harmony default export */ var PagesView = ({
    components: {
        vFooter: com_footer["a" /* default */]

    },
    data: function data() {
        return {};
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/PagesView.vue
//
//
//
//
//
//
//


/* harmony default export */ var views_PagesView = ({
    components: {
        vFooter: com_footer["a" /* default */]

    },
    data: function data() {
        return {};
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcb19f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PagesView.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-page"},[_c('router-view'),_vm._v(" "),_c('v-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_PagesView = (esExports);
// CONCATENATED MODULE: ./src/views/PagesView.vue
function injectStyle (ssrContext) {
  __webpack_require__("7kt1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  views_PagesView,
  selectortype_template_index_0_src_views_PagesView,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_PagesView = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mDSd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// // s1
// {
//     path: 'simbox/poster',
//     component: _import('simbox/poster')
// },

// simbox 动态路由
{
    path: 'simbox/:type',
    component: (0, _import3.default)('simbox/common_simbox')
}];

/***/ }),

/***/ "p9le":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/***
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
exports.default = {
    "common": {
        "submit": "Submit",
        "defaultInput": "please input",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "loginTimeout": "Havne't logged in or session timeout, please login again",
        "noData": "No Data",
        "custom": "Live Chat Support"
    },
    "member_account": {
        "balance": "Balance",
        "recharge": "Top-up",
        "flowHistory": "Data Usage History",
        "purchaseRecord": "Purchasing Record",
        "myData": "My Data",
        "deviceManagement": "Device Management",
        "changePsd": "Change Password",
        "logout": "Logout",
        "acBalance": "My Balance",
        "acFlow": "My Data",
        "acDevice": "My Device",
        "acOrder": "Purchase Record",
        "acDeviceOrder": "Device Order",
        "acFlowStatistics": "Data Usage Summary",
        "acSetting": "Setting ",
        "balanceInfo": "Remaining Balance",
        "rechargeCode": "Top-up Code",
        "enterRechargeCode": "Input the top-up code",
        "gift": "Complementary",
        "returnAccount": "Refund to【My Balance】",
        "certification": "Verified",
        "noCertified": "Non-verified"
    },
    "modify_information": {
        "account": "Account",
        "name": "Name",
        "identification": "Passport or ID No.",
        "countryName": "Residence",
        "id": "Identity Information",
        "edit": "Edit",
        "complete": "Completed",
        "placeholderFirstName": "Input your last name",
        "placeholderName": "Input your first name",
        "firstName": "Last Name",
        "lastName": "First Name",
        "placeholderID": "Input your ID No. / Visa No. / car plate No.",
        "isNull": "unfilled",
        "onlyNumber": "Numbers or letters only",
        "IDTip": "Numbers or letters only"
    },
    "member_modifyPassword": {
        "oldPsd": "Old Password",
        "newPsd": "New Password",
        "title": "Change Password",
        "submit": "Change Password",
        "setUp": "Setting ",
        "accountSetUp": "Account Setting",
        "accountManage": "Account Management",
        "password": "Password",
        "forgetPassword": "Forget Password",
        "loginOut": "Logout",
        "unsubscribe": "Delete user",
        "unsubscribeAfter": "You will lose the rights and benefits after deleting your account",
        "tip1": "Balance from giveaway campaign, manual top-up or voucher redemption",
        "tip2": "Existing and complementary data package",
        "tip3": "Please read it before deleting your account",
        "ucloudlink": "《uCloudlink Account Deletions Notice》",
        "cancellation": "Contact our CS for account deletion",
        "oldPsdNull": "Old password cannot be empty",
        "newPsdNull": "New password cannot be empty",
        "modifyPasswordSuccess": "Password has been changed successfully"
    },
    "member_myDeviceOrder": {
        "title": "Device Order",
        "dicObj": {
            "finished": "Completed",
            "unpaid": "unpaid",
            "cancel": "Cancel order"
        },
        "pending": "Pending Payment",
        "noData": "No data package, go to Data Mall now",
        "noList": "No Data",
        "tryAgainLater": "Please try again later"
    },
    "member_recharge": {
        "recharge": "Top-Up",
        "rechargeAmount": "(Select top-up amount)",
        "present": "Complementary",
        "currentBalance": "Current balance",
        "payAmount": "Top-up amount",
        "unit": "￥",
        "pay": "Confirm payment",
        "alipay": "Alipay",
        "paypal": "Paypal",
        "operateMess": "Operation Reminder",
        "giveMore": "Complementary"
    },
    "member_equipmentManagement": {
        "noData": "No Device?",
        "knowMore": "Go and check",
        "bindDevice": "Link a device",
        "placeholderIMEI": "Please input device's IMEI number",
        "placeholderPwd": "Please input device's initial password",
        "bindNow": "Link up now",
        "myEquipment": "My Device",
        "equipmentMunual": "Device Manual",
        "dataBound": "Unlink",
        "bindSuccess": "Link successfully",
        "unBindSuccess": "Unlink successfully",
        "imeiNull": "IMEI number cannot be empty",
        "pwdNull": "Initial PWD cannot be empty"
    },
    "member_flowRecords": {
        "record": "Data Purchasing Record",
        "filter": "filter",
        "trafficStatistics": "Data Usage Summary"
    },
    "member_balanceDetails": {
        "title": "Purchase Record",
        "filter": "filter",
        "total": "Total",
        "dicObj": {
            "finished": "Completed",
            "unpaid": "unpaid",
            "cancel": "Cancel order"
        }
    },
    "member_productBalanceDetails": {
        "remain": "Remaining data",
        "validTime": "Validity period",
        "coverage": "Service coverage",
        "productIntro": "Description",
        "buyTime": "Purchase Time",
        "unsubscribe": "Unsubscribe",
        "buyTimeTips": "Time based on Beijing, China (GMT+8)",
        "unsubscribeTips": "Unsubscribe successfully, the amount will be refunded to 'My Balance'"
    },
    "users_login": {
        "loginPhone": "Login via phone number",
        "loginEmail": "Login via email",
        "register": "Register an account",
        "inputPhone": "Input the phone number",
        "inputPassword": "Input the password",
        "forgetPassword": "Forgot password",
        "login": "Login",
        "goToLogin": "Login now",
        "inputEmail": "Input the email",
        "smsCode": "SMS verification code",
        "inputSMSCode": "Input the SMS verification code",
        "noReceiveCode": "cannot received the code?",
        "resend": "Resend",
        "nextStep": "Next Step",
        "findByPhone": "Recover password by phone number",
        "findByEmail": "Recover password by email",
        "verifyByEmail": "Go to mailbox for verification",
        "sendEmailTo": "Email has been sent to",
        "findYourPassword": "Please click the attached link and follow the steps to recover your password.",
        "noReceiveEmail": "Cannot receive the email? Please check your junk or deleted folder for any messages from glocalme@ucloudlink.com",
        "or": "or",
        "resetPassword": "Reset password",
        "oldFormat": "at least 6 characters",
        "passwordFormat": "6-20 characters (a combination of letters, numbers or symbols)",
        "completeLogin": "Completed and Login",
        "resetPasswordSuc": "Reset password successfully",
        "backToGlocalMe": "Go to GlocalMe Connect for continue",
        "activeReminder": "The account hasn't been activated, please go to your mailbox to complete your register via the activation link",
        "known": "I understand"
    },
    "users_register": {
        "registerPhone": "Register by phone number",
        "registerEmail": "Register by email",
        "hasAccount": "Already got an account?",
        "agree": "I Agree",
        "agreement": "Glocalme User Agreement",
        "and": "and",
        "policy": "Privacy policy",
        "logoutNotice": "Account delete permanently",
        "submit": "Submit",
        "selectArea": "Select residence",
        "countryOrRegion": "Country/Region",
        "change": "Change",
        "defaultRegion": "Mainland China",
        "AE": "United Arab Emirates",
        "search": "Top searching countries/regions",
        "reminder": "Reminder",
        "reminderTips": "Select【",
        "reminderTips2": "】 as your residential location for exclusive benefits. It cannot be changed in future, are you sure?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "setPassword": "Set the password",
        "registerByEmail": "Click the link to complete your registration",
        "activeSuc": "Activated successfully",
        "activeing": "Activating",
        "activeAgain": "Activate again",
        "activeFail": "Activation Failed",
        "verified": "I have verified",
        "registerSuccess": "Registration success"
    },
    "home": {
        "globalPackageCN": "Global Roaming-free Data Service",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "More than 100 partnerships worldwide",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "Due to system upgrade, you need to select your residence for continue.",
        "reminderTips": "Select【",
        "reminderTips2": "】as your residential location to enjoy exclusive benefits for this area. Your account balance will be ",
        "reminderTips3": "changed according to exchange rate of 【",
        "reminderTips4": "】",
        "reminderTips5": "with the currency of【",
        "reminderTips6": "】.  It can't be changed again, are you sure?",
        "gotoPC": "Go to PC site"
    },
    "privacyPolicy": {
        "changeDate": "Privacy Policy updated notice",
        "changeContain": "This Privacy Policy was last updated on July 2018.",
        "changeContain2": "We respect your privacy. Therefore, we have developed this Privacy Policy that covers how we collect, use, disclose, transfer and store your personal information. We will never disclose your information to any third party without your consent. We will obtain your consent if we wish to use your information for any other unauthorized purpose.",
        "changeContain3": "For more information, please see our full <a href=\"/users/agreement\" target=\"_blank\">《User Agreement》</a> and <a href=\"/users/privacy_policy\" target=\"_blank\">《Privacy Policy》</a>.",
        "noagree": "Cancel",
        "agree": "Agree"
    },
    "service": {
        "selectDevice": "Select the device",
        "company": "Enterprise solution",
        "faqs": "FAQs",
        "afterSale": "Maintenance",
        "manual": "User Manual",
        "safety": "Safety Measures",
        "coverage": "Service coverage"
    },
    "purchase": {
        "buy": "Purchase",
        "online": "Online Shop",
        "offline": "Dealer Shop",
        "distributor": "Distributor",
        "shopAddress": "Shop Address",
        "shopTels": "Contact Number",
        "coverage": "Service Coverage"
    },
    "data_package": {
        "flowShop": "Data Mall",
        "recommend": "Recommended for you",
        "destination": "Select Destination",
        "searchDestination": "Search Destination",
        "historySearch": "Historical search",
        "clean": "empty",
        "more": "more",
        "enjoyPackage": "Unlimited Package",
        "commonPackage": "Data Package",
        "include": "Regional data package including ",
        "areaPackage": "",
        "enjoyDay": "Day Pass",
        "enjoyMonth": "Monthly Pass",
        "unlimited": "Unlimited",
        "houxiansu": "Limited speed afterward",
        "currentMonth": "Valid for the month of purchase",
        "currentDay": "Valid for the day of purchase",
        "immediately": "Valid Immediately",
        "morrow": "Valid in the next day",
        "nextMonth": "Valid in the next month",
        "iDay": "Day",
        "iDays": "Days",
        "iMonth": "Month",
        "iMonths": "Months",
        "cxtcIMonth": "Month  ",
        "antarctica": "Popular",
        "asia": "Asia",
        "european": "Europe",
        "africa": "Africa",
        "northAmerica": "America",
        "southAmerica": "South America",
        "oceania": "Oceania",
        "flow": "Data",
        "period": "Validity Period",
        "applicableArea": "Service coverage",
        "useNotice": "Usage Notice",
        "cost": "Amount to be paid",
        "order": "Order",
        "confirmPay": "Confirm payment",
        "infiniteFlow": "Unlimited data",
        "unsubscribe": "Non-cancellable",
        "subscribe": "Subscribe",
        "payFailed": "Payment Failed",
        "paypalTips": "The payment by Paypal might be delayed due to the authentication of Paypal"
    },
    "pay_result": {
        "orderSuccess": "Ordered Successfully",
        "chargeSuccess": "Top-Up Success",
        "orderSucTips": "The [ ",
        "orderSucTips2": " ] will be transferred to your account in 1 minute, please contact our customer service if you cannot receive it in a long time",
        "orderSucTips3": "It will be active in a minute, please contact our customer support if you still cannot received for a long while.",
        "packageName": "Package Name",
        "chargeAmount": "Balance Top-up",
        "myBalance": "Check My Balance",
        "payAmount": "Payment amount",
        "back": "Back to homepage",
        "myFlow": "Check My Data",
        "tryLater": "Try again later",
        "succeed": "Payment Completed",
        "fail": "Payment failed, please order again",
        "backToShop": "Back to Data Mall",
        "successful": "Transaction successful.",
        "rejected": "Transaction rejected, please contact your bank",
        "unsuccessful": "Transaction unsuccessful, please try again",
        "referenceNumber": "Reference Number"
    },
    "my_order": {
        "month": "Month  ",
        "day": "Day"
    },
    "member_myFlow": {
        "myFlow": "My Data",
        "remainHighSpeedTraffic": "Remaining High Speed",
        "validityPeriod": "Validity Period",
        "day": "Day",
        "month": "Month",
        "status": "Status",
        "invalidPackage": "Expired Package",
        "usageRule": "Usage Policy",
        "close": "Collapse",
        "queryInvalidPackage": "View Expired Packages",
        "mccList": "Service coverage",
        "usageMess": "Usage Notice",
        "payAmount": "Payment Amount",
        "payTime": "Purchase Time",
        "effectiveTime": "Effective Time",
        "validTime": "Valid Time",
        "invalidTime": "Invalid Time",
        "flow": "Data",
        "remainingFlow": "Remaining Data",
        "highSpeedTraffic": "High-Speed Data",
        "remainHighSpeedTraffics": "Remaining High-Speed Data",
        "unsubscribe": "Unsubscribe",
        "unsubscribed": "Unsubscribed",
        "isCancelPackage": "Unsubscribe this package?",
        "actionTip1": "Notice: order by Paypal will have extra ",
        "actionTip2": " Administrative charge",
        "reBack": "Refund to【My Balance】",
        "cancel": "Cancel",
        "cancelSuccess": "Unsubscribe Successfully",
        "reBackBy": "Refund successfully to 【My Balance】",
        "iKnow": "I understand",
        "usageRule1": "Unlimited package will be consumed in priority",
        "usageRule2": "The usage priority of data packages in same type are default in the order of purchase time.",
        "usageRule3": "When the high-speed data is finished, it will automatically switch to a general package",
        "packageUsageRule": "Package usage policy",
        "dicObj": {
            "notActivated": "inactivated",
            "inUsing": "in use",
            "useEnd": "finished",
            "expire": "expired",
            "transfer": "Transferred",
            "unsubscribe": "Unsubscribe",
            "valid": "Valid  ",
            "invalid": "Invalid",
            "currentMonth": "Valid for the month of purchase"
        },
        "to": " till",
        "noData": "No data package, go to Data Mall now",
        "noList": "No Data",
        "accumulatedThisHour": "1-hour Accumulation",
        "accumulatedThisDay": "Today Accumulation",
        "accumulatedThisMonth": "This Month Accumulation",
        "accumulatedThisYear": "This Year Accumulation",
        "accumulatedFlow": "Accumulated Data",
        "flowDetail": "Data Detail"
    },
    "select_area": {
        "destination": "Select Destination",
        "selectCountry": "Select the hottest countries/regions"
    },
    "footer": {
        "belongs": "Your account belongs to ",
        "comeTo": "You are now in ",
        "site": " site",
        "changeTips": "Your account can't be switched to other countries/region",
        "changeTips2": "If you need to change the location, please logout",
        "switchWebsite": "The site does not match your home country.Please log out to continue browsing."
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside is the innovative global mobile data service provided by uCloudlink. With the built-in GlocalMe Connect Mobile Application, world phone users can enjoy the unprecedented data connection experience carried by the patented CloudSIM technology. ",
            "title1": "Convenience",
            "content1": "With its worldwide coverage, GlocalMe® Inside offers convenient and seamless mobile data usage experience for business travellers.",
            "title2": "Always Connected to the Best Network",
            "content2": "The intelligent network selection technology of GlocalMe® Inside enables users to connect the best local network at all time.",
            "title3": "Fair Charge",
            "content3": "Thanks to the extensive carrier partnerships in more than 100 countries and regions，GlocalMe® Inside delivers local data package in fair charge",
            "title4": "Information Security",
            "content4": "As compared with Wi-Fi，network connection provided by GlocalMe® Inside offers high security and privacy protection for its users.",
            "title5": "GlocalMe® Inside World Phone，One for Worldwide "
        },
        "u2": {
            "title": "U2",
            "title1_1": "Connect Fashionably",
            "title1_2": "GlocalMe U2",
            "title2": "Stylish and Lightweight",
            "title3_1": "Metallic Gold",
            "title3_2": "Space Grey",
            "title4": "Light and Slim for More Compactable",
            "title5": "Enjoy 4G High Speed Network All the Time",
            "title6": "Specification",
            "title7_1": "Stay Connected Wherever You Are",
            "title7_2": "GlocalMe Roaming-free Mobile Network Service covers more than 100 countries and regions across 5 continents in the world",
            "title7_3": "Mobile Connection in anytime, anywhere"
        },
        "g3": {
            "title1_1": "Long-lasting Roaming-free Portable Wi-Fi",
            "title1_2": "Flagship Model GlocalMe G3",
            "title2_1": "Must Have Travel Gadget",
            "title3_1": "Black X Grey",
            "title3_2": "White X Gold",
            "title4_1": "100+ Countries and Regions Covered",
            "title4_2": "Service covers over 100 countries and regions across 5 continents",
            "title4_3": "SIM-FREE experience for your mobile connection at anytime, anywhere",
            "title4_4": "More in Service Coverage",
            "title5_1": "Power On for Whole Day Connection",
            "title5_2": "G3 doubles up as a power pack to keep your devices charged",
            "title5_3": "Built-in 5350mAh Lithium-ion Battery for 15 hours of continuous usage.",
            "title5_4": "",
            "title6_1": "Roaming-free for the Best Local Network",
            "title6_2": "Self-developed CloudSIM technology for real-time selection of optimal local network",
            "title7_1": "Joy of Sharing",
            "title7_2": "Connecting 5 devices seamlessly, including smartphone, notepad, laptop and wearable smart devices",
            "title8_1": "User-friendly APP Management",
            "title8_2": "Credits top-up, data packages purchase, data usage and device monitoring are all in single mobile application. Online payment includes credit card, PayPal, Unionpay, WeChat Pay and Alipay",
            "title8_3": "Scan to download，GlocalMe Mobile Application",
            "title9_1": "Contract-less with Charging Flexibility",
            "title9_2": "Data Package: ",
            "title9_3": "Suit your needs with variety choice including geographic location, validity and data volume ",
            "title9_4": "Pay-As-You-Go",
            "title9_5": "Charge based on actual usage with daily maximum charge for unlimitated data,Details in Data Mall",
            "title9_6": "Private Hotspot",
            "title9_7": "Enhance your information security by Wi-Fi encrytion",
            "title9_8": "Protect you from public Wi-Fi usage risk"
        },
        "p3": {
            "title1_1": "What Color Best Describes You?",
            "title1_2": "Colour your life with favourite colour. This is not only a mobile phone but the harmony of technology, design and quality.",
            "title3": "Enabled by CloudSIM technology, no roaming and SIMs any more",
            "title4": "Share Every Moments With Families and Friends",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "With the GlocalMe® Connect APP which is equipped in the World Phone, users can enjoy the unbeatable data connection experience by CloudSIM technology.",
            "title6_1": "Wait! There's More!",
            "title6_2": "Our service included"
        },
        "simbox": {
            "title": "SIMBOX",
            "title1": "Make Any Phone Multi-SIM Multi-Standby",
            "title2": "15 Advantages to Satisfy the Demand of Multi-card Users",
            "title3": "Transforming a Smart Phone into Multi-card Multi-Srandby",
            "title4": "No Roaming Charge for International Calls",
            "title5": "The Real 4G Fits in All Types of Network",
            "title6_1": "24/7 Online",
            "title6_2": "Never Miss Any Calls and SMS",
            "title7": "Exquisite, Fashionable and Simple"
        },
        "glocalme_wifi": {
            "title": "Why prefer GlocalMe portable Wi-Fi"
        },
        "glocalme_phone": {
            "title": "Why prefer GlocalMe World Phone"
        }
    },
    "about": {
        "contact": "Contact us",
        "news": "Newsroom",
        "glocalme": "About GlocalMe",
        "partnership": "Cooperation",
        "partnerships": "Partnership",
        "note": "To ensable us to understand your interest, please fill in the form below. We will contact you soon!",
        "username": "Name",
        "firstname": "First name",
        "lastname": "Last name",
        "email": "E-mail",
        "company": "Company Name",
        "position": "Position",
        "phone": "Phone",
        "demand": "Details",
        "success": "Success",
        "deviceType": "Main Product of Interest",
        "quantity": "Estimated Quantity of Product",
        "address": "Address",
        "heard": "How did you hear about us？",
        "agreement": "Subscribe to our news letter to receive exclusive deals"
    },
    "validate": {
        "isEmail": "Email Format",
        "isMobilePhone": "Mobile Number",
        "isChinaName": "Name in Chinese",
        "required": "Required",
        "format": " not in the correct format",
        "min": "Must be at least ",
        "max": "No longer than ",
        "char": " characters",
        "equal": "Input did not match",
        "invalid": "Your input contains invalid characters, such as <>, ><, etc.",
        "digits": "Estimated Quantity of Product"
    },
    "newCreate": {
        "onlyForAE": "This device is for users with resident location as UAE",
        "purchaseTips": ""
    }
};

/***/ }),

/***/ "qWdx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// 登录
{
    path: 'users/login',
    name: 'login',
    component: (0, _import3.default)('users/login')
},
// 找回密码 手机
{
    path: 'users/forgot_password',
    name: 'forgot_password',
    component: (0, _import3.default)('users/forgot_password')
},
// 找回密码 邮箱
{
    path: 'users/forgot_password_email',
    name: 'forgot_password_email',
    component: (0, _import3.default)('users/forgot_password_email')
},
// 充值
{
    path: 'users/top_up',
    name: 'top_up',
    component: (0, _import3.default)('users/top_up'),
    meta: {
        requiresAuth: true
    }
},
// 用户协议
{
    path: 'users/agreement',
    name: 'agreement',
    component: (0, _import3.default)('register/agreement')
},
// 隐私政策
{
    path: 'users/privacy_policy',
    name: 'privacy_policy',
    component: (0, _import3.default)('register/privacy_policy')
},
// 注销须知
{
    path: 'users/logout_notice',
    name: 'logout_notice',
    component: (0, _import3.default)('member/logout_notice')
}];

/***/ }),

/***/ "qcJA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// 手机注册
{
    path: 'register/mobilephone',
    name: 'mobilephone',
    component: (0, _import3.default)('register/mobilephone')
},
// 邮箱注册
{
    path: 'register/email',
    name: 'email',
    component: (0, _import3.default)('register/email')
}];

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9fa4da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("NeJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tVOT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _api = __webpack_require__("h2kg");

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by xuetao.liu on 2018/10/9.
 * @Description mounted common plugin or lib
 */
exports.default = {
  install: function install(Vue, options) {
    Vue.prototype.$http = _request2.default;
    Vue.prototype.$api = _api2.default;
  }
};

/***/ }),

/***/ "uOPr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import where_to_buy from '../views/glocalme/where_to_buy';

exports.default = [
// 流量商城
{
    path: 'data_package/index',
    name: 'data_package/index',
    component: (0, _import3.default)('data_package')
},
// 套餐购买结算
{
    path: 'data_package/settlement',
    name: 'settlement',
    component: (0, _import3.default)('data_package/settlement')
}, {
    path: 'data_package/payResult',
    name: 'payResult',
    component: (0, _import3.default)('data_package/payResult'),
    meta: {
        requiresAuth: true
    }
}, {
    path: 'data_package/select',
    name: 'select',
    component: (0, _import3.default)('data_package/select_area')
}, {
    path: 'data_package/:country',
    name: 'data_package/country',
    component: (0, _import3.default)('data_package')
}];

/***/ }),

/***/ "vLgD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__("Y+qm");

var _index2 = _interopRequireDefault(_index);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _eventLib = __webpack_require__("5DhB");

var _eventLib2 = _interopRequireDefault(_eventLib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_index2.default);

/**
* @type {AxiosInstance}
*/
/**
* @author huancheng.zhan<huancheng.zhan@ukelink.com>
* @description
* @since 2018/3/12
*/

var service = _axios2.default.create({
  timeout: 60000
});
/**
* 请求拦截
**/
service.interceptors.request.use(function (config) {

  var IsShow = _vue2.default.$vux.loading.isVisible();
  if (!IsShow && !config["notShowLoading"]) {
    _vue2.default.$vux.loading.show({
      text: 'Loading'
    });
  }

  config.headers['Accept-Language'] = _jsCookie2.default.get('language') || navigator.language;

  var partnerCode = _vue2.default.prototype.ObjectMvno && _vue2.default.prototype.ObjectMvno['partnerCodeP'] ? _vue2.default.prototype.ObjectMvno['partnerCodeP'] : 'UKWEB';

  var default_param = {
    streamNo: partnerCode + ('' + +new Date() + Math.floor(Math.random() * 10000)),
    partnerCode: partnerCode
  };
  var domain = _vue2.default.prototype.commonHelper.apiDomain();
  config.url = config.url;
  if (config["noPartnerCode"]) {
    delete default_param.partnerCode;
  }
  if (config.url.indexOf('/interfaces/getMvnoCode') !== -1) {

    delete config.data;
  } else {
    config.data = (0, _assign2.default)({}, config.data, default_param);
  }

  return config;
});
/**
* 响应拦截
**/
service.interceptors.response.use(function (response) {

  _vue2.default.$vux.loading.hide();

  var code = response.data.resultCode || response.data["subCode"];
  var result = response.data;
  if (code === "00000000" || code === "0000") {
    _vue2.default.prototype.NotInterceptors = false;
    return result;
  } else if (code === "00000006" || code === "00000007" || code === "00000008" || code === "00000026") {

    if (_vue2.default.prototype.NotInterceptors) {
      _vue2.default.prototype.NotInterceptors = false;
      _jsCookie2.default.remove("access_token", { domain: '.' + location.hostname });
      sessionStorage.clear();
      localStorage.clear();
      return _promise2.default.reject(result);
    }
    _jsCookie2.default.remove("access_token", { domain: '.' + location.hostname });
    sessionStorage.clear();
    localStorage.clear();
    _eventLib2.default.emit("loginTimeout");
    return _promise2.default.reject(result);
  } else {
    _vue2.default.prototype.NotInterceptors = false;
    return _promise2.default.reject(result);
  }
}, function (error) {

  _vue2.default.$vux.loading.hide();
  _vue2.default.prototype.NotInterceptors = false;

  if (error.response) {
    return _promise2.default.reject(error.response);
  }
});

exports.default = service;

/***/ }),

/***/ "y7FU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _import2 = __webpack_require__("5tgt");

var _import3 = _interopRequireDefault(_import2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
// // s1
// {
//     path: 'worldphone/s1',
//     component: _import('worldphone/s1')
// },
// // p3
// {
//     path: 'worldphone/p3',
//     component: _import('worldphone/p3')
// },
// // why_glocalme_world_phone
// {
//     path: 'worldphone/why_glocalme_world_phone',
//     component: _import('worldphone/why_glocalme_world_phone')
// },
// // s20i
// {
//     path: 'worldphone/s20i',
//     component: _import('worldphone/s20i')
// },

// worldphone 动态路由
{
    path: 'worldphone/:type',
    component: (0, _import3.default)('worldphone/common_phone')
}];

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app_1.1.05.9_00f63dfaac1957e5dc4f.js